import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard');
import { HostListener, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard/view.scss */
:host {
  display: block;
  min-height: 100%;
  overflow-x: hidden;
  color: var(--workroom-text);
  --workroom-text: #111111;
  --workroom-text-soft: #3f3f3f;
  --workroom-muted: #707070;
  --workroom-faint: #9a9a9a;
  --workroom-ink: #0f0f0f;
  --workroom-ink-hover: #2a2a2a;
  --workroom-border: #dddddd;
  --workroom-divider: #ececec;
  --workroom-panel: #ffffff;
  --workroom-panel-muted: #f3f4f4;
  --workroom-panel-subtle: #fbfbfa;
  --workroom-hover: #f5f5f4;
  --workroom-focus: #111111;
  --workroom-radius: 8px;
  --workroom-radius-sm: 6px;
  --workroom-section-gap: 20px;
  --workroom-card-padding: 18px;
  --workroom-badge-neutral-bg: #f2f2f1;
  --workroom-badge-neutral-border: #dededc;
  --workroom-badge-neutral-text: #555555;
  --workroom-badge-blue-bg: #eef3f4;
  --workroom-badge-blue-border: #dbe4e6;
  --workroom-badge-blue-text: #3f5960;
  --workroom-badge-green-bg: #eef4f0;
  --workroom-badge-green-border: #dbe6df;
  --workroom-badge-green-text: #3f5f4d;
  --workroom-badge-warm-bg: #f5f1e9;
  --workroom-badge-warm-border: #e7decf;
  --workroom-badge-warm-text: #66563c;
  --workroom-badge-red-bg: #f6f0f0;
  --workroom-badge-red-border: #eadede;
  --workroom-badge-red-text: #704f4f;
  --workroom-badge-violet-bg: #f1f1f4;
  --workroom-badge-violet-border: #dedfe5;
  --workroom-badge-violet-text: #555966;
}

:host ::ng-deep select,
:host ::ng-deep input,
:host ::ng-deep textarea {
  letter-spacing: 0;
  background-color: var(--workroom-panel);
  border-color: var(--workroom-border);
  color: var(--workroom-text);
}

:host ::ng-deep button,
:host ::ng-deep a,
:host ::ng-deep select,
:host ::ng-deep input,
:host ::ng-deep textarea {
  outline-offset: 2px;
}

:host ::ng-deep button:focus-visible,
:host ::ng-deep a:focus-visible,
:host ::ng-deep select:focus-visible,
:host ::ng-deep input:focus-visible,
:host ::ng-deep textarea:focus-visible,
:host ::ng-deep [role=button]:focus-visible {
  outline: 2px solid var(--workroom-focus);
  outline-offset: 2px;
  box-shadow: none;
}

:host ::ng-deep select:focus,
:host ::ng-deep input:focus,
:host ::ng-deep textarea:focus {
  border-color: var(--workroom-focus) !important;
  box-shadow: 0 0 0 2px rgba(17, 17, 17, 0.08) !important;
}

:host ::ng-deep h1,
:host ::ng-deep h2,
:host ::ng-deep h3,
:host ::ng-deep p,
:host ::ng-deep span,
:host ::ng-deep button {
  overflow-wrap: anywhere;
}

:host ::ng-deep main {
  color: var(--workroom-text);
}

:host ::ng-deep main > section {
  margin-bottom: var(--workroom-section-gap);
}

:host ::ng-deep main > div.grid,
:host ::ng-deep section.space-y-5,
:host ::ng-deep section.space-y-4 {
  gap: var(--workroom-section-gap);
}

:host ::ng-deep [class~=text-zinc-950],
:host ::ng-deep [class~=text-zinc-900] {
  color: var(--workroom-text) !important;
}

:host ::ng-deep [class~=text-zinc-700],
:host ::ng-deep [class~=text-zinc-600] {
  color: var(--workroom-text-soft) !important;
}

:host ::ng-deep [class~=text-zinc-500],
:host ::ng-deep [class~=text-zinc-400] {
  color: var(--workroom-muted) !important;
}

:host ::ng-deep [class~=border-zinc-100],
:host ::ng-deep [class~=border-zinc-200],
:host ::ng-deep [class~=border-zinc-300] {
  border-color: var(--workroom-border) !important;
}

:host ::ng-deep [class~=divide-zinc-100] > :not([hidden]) ~ :not([hidden]),
:host ::ng-deep [class~=divide-zinc-200] > :not([hidden]) ~ :not([hidden]) {
  border-color: var(--workroom-divider) !important;
}

:host ::ng-deep [class~=bg-white],
:host ::ng-deep [class~="bg-white/95"],
:host ::ng-deep [class~="bg-white/90"],
:host ::ng-deep [class~="bg-white/70"] {
  background-color: var(--workroom-panel) !important;
}

:host ::ng-deep [class~=bg-zinc-50],
:host ::ng-deep [class~="bg-zinc-50/70"],
:host ::ng-deep [class~=bg-zinc-100] {
  background-color: var(--workroom-panel-muted) !important;
}

:host ::ng-deep [class~=bg-zinc-950] {
  background-color: var(--workroom-ink) !important;
}

:host ::ng-deep [class~="hover:bg-zinc-800"]:hover {
  background-color: var(--workroom-ink-hover) !important;
}

:host ::ng-deep button:not(.wr-status):not(.wr-tag):not([class~=bg-zinc-950]):not([class~=bg-rose-700]):hover,
:host ::ng-deep [role=button]:not(.wr-status):hover,
:host ::ng-deep tr[class*="hover:"]:hover {
  background-color: var(--workroom-hover) !important;
}

:host ::ng-deep article:hover,
:host ::ng-deep button:hover,
:host ::ng-deep [role=button]:hover {
  border-color: #cfcfcf !important;
}

:host ::ng-deep section.rounded-lg,
:host ::ng-deep article.rounded-lg,
:host ::ng-deep aside.rounded-lg,
:host ::ng-deep div.rounded-lg {
  border-radius: var(--workroom-radius) !important;
}

:host ::ng-deep button.rounded-md,
:host ::ng-deep span.rounded-md,
:host ::ng-deep select.rounded-md,
:host ::ng-deep input.rounded-md,
:host ::ng-deep textarea.rounded-md,
:host ::ng-deep div.rounded-md {
  border-radius: var(--workroom-radius-sm) !important;
}

:host ::ng-deep [class~=shadow-sm] {
  box-shadow: none !important;
}

:host ::ng-deep [class~=shadow-2xl] {
  box-shadow: 0 18px 45px rgba(17, 17, 17, 0.14) !important;
}

:host ::ng-deep .wr-quick-backdrop {
  background: rgba(17, 17, 17, 0.1);
}

:host ::ng-deep .wr-quick-panel {
  box-shadow: 0 16px 36px rgba(17, 17, 17, 0.1);
}

:host ::ng-deep .wr-quick-header,
:host ::ng-deep .wr-quick-footer {
  background-color: var(--workroom-panel-subtle) !important;
}

:host ::ng-deep .wr-quick-form {
  display: grid;
  gap: 16px;
}

:host ::ng-deep .wr-quick-section {
  display: grid;
  gap: 12px;
}

:host ::ng-deep .wr-quick-field {
  display: block;
  min-width: 0;
}

:host ::ng-deep .wr-quick-label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-height: 16px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
  color: var(--workroom-muted);
}

:host ::ng-deep .wr-quick-required {
  display: inline-flex;
  align-items: center;
  min-height: 18px;
  border: 1px solid var(--workroom-divider);
  border-radius: 999px;
  padding: 0 6px;
  font-size: 10px;
  font-weight: 600;
  color: var(--workroom-faint);
  background-color: var(--workroom-panel);
}

:host ::ng-deep .wr-quick-control {
  height: 40px;
  padding: 0 11px;
  border-color: var(--workroom-border) !important;
  background-color: var(--workroom-panel) !important;
  color: var(--workroom-text);
  line-height: 1.4;
  transition: border-color 160ms ease, box-shadow 160ms ease, background-color 160ms ease;
}

:host ::ng-deep textarea.wr-quick-control {
  height: auto;
  min-height: 84px;
  padding: 10px 11px;
  line-height: 1.55;
  resize: vertical;
}

:host ::ng-deep textarea.wr-quick-control[rows="2"] {
  min-height: 72px;
}

:host ::ng-deep .wr-quick-control::placeholder {
  color: var(--workroom-faint);
}

:host ::ng-deep .wr-quick-help {
  margin-top: 6px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
}

:host ::ng-deep .wr-quick-help-error {
  color: var(--workroom-badge-red-text);
}

:host ::ng-deep .wr-quick-type-option {
  min-height: 56px;
  box-shadow: none !important;
}

:host ::ng-deep .wr-quick-type-option[class~=border-zinc-950] {
  border-color: var(--workroom-ink) !important;
  background-color: var(--workroom-panel-muted) !important;
}

:host ::ng-deep .wr-quick-alert {
  background-color: var(--workroom-panel);
  border-color: var(--workroom-divider) !important;
}

:host ::ng-deep .wr-quick-cancel,
:host ::ng-deep .wr-quick-save {
  justify-content: center;
}

:host ::ng-deep .wr-quick-save {
  min-width: 88px;
}

:host ::ng-deep .wr-state {
  border: 1px solid var(--workroom-divider);
  border-radius: var(--workroom-radius);
  background-color: transparent !important;
  padding: 18px;
  text-align: left;
}

:host ::ng-deep .wr-state--compact {
  padding: 14px;
}

:host ::ng-deep .wr-state--empty {
  border-style: dashed;
}

:host ::ng-deep .wr-state--error {
  border-color: var(--workroom-badge-red-border) !important;
}

:host ::ng-deep .wr-state--loading {
  border-color: var(--workroom-divider) !important;
}

:host ::ng-deep .wr-state-label {
  margin: 0;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--workroom-faint) !important;
}

:host ::ng-deep .wr-state-title {
  margin: 0;
  font-size: 14px;
  font-weight: 650;
  line-height: 1.45;
  color: var(--workroom-text) !important;
}

:host ::ng-deep .wr-state-label + .wr-state-title {
  margin-top: 6px;
}

:host ::ng-deep .wr-state-copy {
  margin: 4px 0 0;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.65;
  color: var(--workroom-muted) !important;
}

:host ::ng-deep .wr-state-action {
  display: inline-flex;
  min-height: 0;
  height: 30px;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--workroom-border);
  border-radius: var(--workroom-radius-sm);
  background-color: var(--workroom-panel) !important;
  padding: 0 10px;
  font-size: 12px;
  font-weight: 650;
  line-height: 1;
  color: var(--workroom-text-soft) !important;
  transition: border-color 160ms ease, background-color 160ms ease, color 160ms ease;
}

:host ::ng-deep .wr-state-action:hover {
  border-color: #c8c8c8 !important;
  background-color: var(--workroom-hover) !important;
  color: var(--workroom-text) !important;
}

:host ::ng-deep .wr-state-action:disabled {
  cursor: not-allowed;
  opacity: 0.48;
}

:host ::ng-deep .wr-state-lines {
  display: grid;
  gap: 8px;
  max-width: 420px;
}

:host ::ng-deep .wr-state-lines span {
  display: block;
  height: 1px;
  overflow: hidden;
  background: linear-gradient(90deg, var(--workroom-divider), #d8d8d8, var(--workroom-divider));
  background-size: 220% 100%;
  animation: wr-state-line 1.2s ease-in-out infinite;
}

:host ::ng-deep .wr-state-lines span:nth-child(2) {
  width: 74%;
  animation-delay: 120ms;
}

:host ::ng-deep .wr-state-lines span:nth-child(3) {
  width: 46%;
  animation-delay: 240ms;
}

:host ::ng-deep .wr-media-state {
  background-color: var(--workroom-panel-muted) !important;
}

@keyframes wr-state-line {
  0% {
    background-position: 120% 0;
  }
  100% {
    background-position: -120% 0;
  }
}
:host ::ng-deep .p-5 {
  padding: var(--workroom-card-padding) !important;
}

:host ::ng-deep section.rounded-lg article.rounded-lg,
:host ::ng-deep article.rounded-lg article.rounded-lg,
:host ::ng-deep aside.rounded-lg [class~=rounded-lg][class~=border],
:host ::ng-deep [class~=border-dashed] {
  background-color: var(--workroom-panel-subtle) !important;
}

:host ::ng-deep .workroom-thumbnail {
  background-color: var(--workroom-panel-muted) !important;
}

:host ::ng-deep .wr-gallery-card {
  box-shadow: none;
  transition: border-color 160ms ease, background-color 160ms ease;
}

:host ::ng-deep .wr-gallery-card:hover {
  background-color: var(--workroom-panel-subtle);
  border-color: #c8c8c8 !important;
}

:host ::ng-deep .wr-gallery-trigger {
  min-height: 100%;
}

:host ::ng-deep .wr-gallery-thumbnail {
  border-bottom: 1px solid var(--workroom-divider);
}

:host ::ng-deep .wr-gallery-thumbnail img {
  display: block;
}

:host ::ng-deep .wr-gallery-status {
  min-height: 32px;
  color: var(--workroom-text-soft);
}

:host ::ng-deep .wr-list-panel,
:host ::ng-deep .wr-board-column,
:host ::ng-deep .wr-project-section {
  box-shadow: none;
}

:host ::ng-deep .wr-list-row,
:host ::ng-deep .wr-board-card,
:host ::ng-deep .wr-project-item {
  background-color: var(--workroom-panel);
  transition: background-color 160ms ease, border-color 160ms ease;
}

:host ::ng-deep .wr-list-row:hover,
:host ::ng-deep .wr-list-row:focus-visible,
:host ::ng-deep .wr-board-card:hover,
:host ::ng-deep .wr-project-item:hover,
:host ::ng-deep .wr-project-item:focus-visible {
  background-color: var(--workroom-panel-subtle) !important;
}

:host ::ng-deep .wr-list-row:focus-visible,
:host ::ng-deep .wr-project-item:focus-visible {
  outline: 2px solid var(--workroom-focus);
  outline-offset: -2px;
}

:host ::ng-deep .wr-board-grid {
  align-items: start;
}

:host ::ng-deep .wr-board-column {
  min-height: 320px;
  background-color: rgba(255, 255, 255, 0.78) !important;
}

:host ::ng-deep .wr-board-column > div:last-child {
  min-height: 240px;
}

:host ::ng-deep .wr-board-card {
  border-color: var(--workroom-divider) !important;
}

:host ::ng-deep .wr-project-section {
  background-color: var(--workroom-panel) !important;
}

:host ::ng-deep .wr-project-item {
  min-height: 104px;
}

:host ::ng-deep .wr-status,
:host ::ng-deep .wr-chip,
:host ::ng-deep .wr-tag {
  max-width: 100%;
  border-width: 1px;
  border-style: solid;
  white-space: normal;
  overflow-wrap: anywhere;
  text-align: left;
}

:host ::ng-deep .wr-status-draft,
:host ::ng-deep .wr-kind-proposal,
:host ::ng-deep .wr-type-reference,
:host ::ng-deep .wr-tag-tone-3 {
  background-color: var(--workroom-badge-warm-bg) !important;
  border-color: var(--workroom-badge-warm-border) !important;
  color: var(--workroom-badge-warm-text) !important;
}

:host ::ng-deep .wr-status-progress,
:host ::ng-deep .wr-kind-presentation,
:host ::ng-deep .wr-type-work,
:host ::ng-deep .wr-tag-tone-1 {
  background-color: var(--workroom-badge-blue-bg) !important;
  border-color: var(--workroom-badge-blue-border) !important;
  color: var(--workroom-badge-blue-text) !important;
}

:host ::ng-deep .wr-status-review,
:host ::ng-deep .wr-kind-memo,
:host ::ng-deep .wr-tag-tone-4 {
  background-color: var(--workroom-badge-red-bg) !important;
  border-color: var(--workroom-badge-red-border) !important;
  color: var(--workroom-badge-red-text) !important;
}

:host ::ng-deep .wr-status-done,
:host ::ng-deep .wr-kind-image,
:host ::ng-deep .wr-type-output,
:host ::ng-deep .wr-tag-tone-2 {
  background-color: var(--workroom-badge-green-bg) !important;
  border-color: var(--workroom-badge-green-border) !important;
  color: var(--workroom-badge-green-text) !important;
}

:host ::ng-deep .wr-status-archive,
:host ::ng-deep .wr-kind-document,
:host ::ng-deep .wr-kind-etc,
:host ::ng-deep .wr-type-note,
:host ::ng-deep .wr-type-etc,
:host ::ng-deep .wr-tag-tone-0 {
  background-color: var(--workroom-badge-neutral-bg) !important;
  border-color: var(--workroom-badge-neutral-border) !important;
  color: var(--workroom-badge-neutral-text) !important;
}

:host ::ng-deep .wr-kind-link {
  background-color: var(--workroom-badge-violet-bg) !important;
  border-color: var(--workroom-badge-violet-border) !important;
  color: var(--workroom-badge-violet-text) !important;
}

:host ::ng-deep .wr-type-project,
:host ::ng-deep .wr-tag-active {
  background-color: var(--workroom-ink) !important;
  border-color: var(--workroom-ink) !important;
  color: #ffffff !important;
}

:host ::ng-deep .wr-tag:hover {
  filter: brightness(0.98);
}

@media (max-width: 640px) {
  :host ::ng-deep main,
  :host ::ng-deep section,
  :host ::ng-deep article,
  :host ::ng-deep aside,
  :host ::ng-deep div {
    min-width: 0;
    max-width: 100%;
  }
  :host ::ng-deep button,
  :host ::ng-deep a,
  :host ::ng-deep select,
  :host ::ng-deep input {
    min-height: 44px;
  }
  :host ::ng-deep button,
  :host ::ng-deep a {
    min-width: 44px;
  }
  :host ::ng-deep [role=button] {
    min-height: 44px;
  }
  :host ::ng-deep .wr-gallery-card,
  :host ::ng-deep .wr-list-panel,
  :host ::ng-deep .wr-project-section {
    overflow: hidden;
  }
  :host ::ng-deep .wr-gallery-status {
    max-width: 45vw;
  }
  :host ::ng-deep .wr-list-row,
  :host ::ng-deep .wr-project-item {
    grid-template-columns: minmax(0, 1fr) !important;
  }
  :host ::ng-deep table {
    font-size: 12px;
  }
  :host ::ng-deep .wr-quick-backdrop {
    background: rgba(17, 17, 17, 0.08);
  }
  :host ::ng-deep .wr-quick-panel {
    max-width: none;
    border-left: 0 !important;
    box-shadow: none;
  }
  :host ::ng-deep .wr-quick-footer > div:last-child {
    align-items: stretch;
  }
  :host ::ng-deep .wr-quick-cancel,
  :host ::ng-deep .wr-quick-save {
    flex: 1;
  }
}`],
})
export class PageDashboardComponent implements OnInit {
    public activeView: string = "dashboard";
    public activeType: string = "all";
    public activeKind: string = "all";
    public activeStatus: string = "all";
    public activeTag: string = "all";
    public activeProject: string = "all";
    public exportProjectId: string = "all";
    public activeDate: string = "all";
    public activeSort: string = "updated-desc";
    public searchText: string = "";
    public selectedItem: any = null;
    public taskRows: any[] = [];
    public deletingItem: boolean = false;
    public statusOverrides: any = {};
    public taskLoading: boolean = true;
    public taskLoadFailed: boolean = false;
    public taskLoadMessage: string = "";
    public quickPanelOpen: boolean = false;
    public savingQuick: boolean = false;
    public quickNotice: string = "";
    public quickSaveFailed: boolean = false;
    public mediaFailures: any = {};
    public resourceFailures: any = {};
    private localQuickItems: any[] = [];
    private localQuickProjects: any[] = [];

    public quickForm: any = {
        title: "",
        type: "work",
        kind: "proposal",
        projectId: "sirius-workroom",
        status: "초안",
        due: "",
        tags: "",
        summary: "",
        reference: "",
        checklist: "",
        linkLabel: "",
        linkUrl: "",
    };

    public viewModes: any[] = [
        { key: "dashboard", label: "카탈로그" },
        { key: "gallery", label: "갤러리" },
        { key: "list", label: "리스트" },
        { key: "board", label: "보드" },
        { key: "project", label: "프로젝트" },
    ];

    public contentTypes: any[] = [
        { key: "all", label: "전체" },
        { key: "project", label: "프로젝트" },
        { key: "work", label: "작업물" },
        { key: "reference", label: "참고자료" },
        { key: "output", label: "결과물" },
        { key: "note", label: "체크리스트/메모" },
    ];

    public kindFilters: any[] = [
        { key: "all", label: "전체 유형" },
        { key: "presentation", label: "발표자료" },
        { key: "proposal", label: "제안서" },
        { key: "document", label: "문서" },
        { key: "image", label: "이미지" },
        { key: "link", label: "링크" },
        { key: "memo", label: "메모" },
        { key: "etc", label: "기타" },
    ];

    public statusFilters: any[] = [
        { key: "all", label: "전체 상태" },
        { key: "초안", label: "초안" },
        { key: "진행 중", label: "진행 중" },
        { key: "검토 필요", label: "검토 필요" },
        { key: "완료", label: "완료" },
        { key: "보관", label: "보관" },
    ];
    public statusOptions: any[] = [
        { key: "초안", label: "초안" },
        { key: "진행 중", label: "진행 중" },
        { key: "검토 필요", label: "검토 필요" },
        { key: "완료", label: "완료" },
        { key: "보관", label: "보관" },
    ];
    public quickKindOptions: any[] = [
        { key: "presentation", label: "발표자료" },
        { key: "proposal", label: "제안서" },
        { key: "document", label: "문서" },
        { key: "image", label: "이미지" },
        { key: "link", label: "링크" },
        { key: "memo", label: "메모" },
        { key: "etc", label: "기타" },
    ];

    public sortOptions: any[] = [
        { key: "updated-desc", label: "최근 수정순" },
        { key: "created-desc", label: "최근 생성순" },
        { key: "title-asc", label: "제목순" },
        { key: "completion-desc", label: "완료순" },
        { key: "project-asc", label: "프로젝트순" },
    ];
    public dateFilters: any[] = [
        { key: "all", label: "전체 날짜" },
        { key: "today", label: "오늘" },
        { key: "this-week", label: "이번 주" },
        { key: "this-month", label: "이번 달" },
        { key: "done-archive", label: "완료/보관" },
        { key: "unscheduled", label: "날짜 미정" },
    ];

    public projects: any[] = [
        {
            id: "sirius-workroom",
            title: "Sirius Workroom 개편",
            status: "진행 중",
            owner: "김지원",
            summary: "작업물, 프로젝트, 참고자료, 결과물을 한 화면에서 연결하는 개인 작업 공간 개편",
        },
        {
            id: "highschool-credit",
            title: "고교학점제 운영 지원 자료",
            status: "검토 필요",
            owner: "김지원",
            summary: "제안서와 발표자료를 묶은 교육 운영 지원 패키지",
        },
        {
            id: "heritage-proposal",
            title: "국가유산 분류 시각자료",
            status: "완료",
            owner: "김지원",
            summary: "분류체계, 본문 삽입용 시각자료, 참고 렌더 보관",
        },
        {
            id: "monthly-seminar",
            title: "월간 세미나 공유 자료",
            status: "완료",
            owner: "김지원",
            summary: "Season Docs 작업 과정과 산출물을 공유하는 발표자료",
        },
        {
            id: "northeast-culture-history-foundation",
            title: "동북아역사재단",
            status: "초안",
            owner: "김지원",
            summary: "재단 관련 자료와 산출물을 정리하기 위한 프로젝트",
        },
    ];
    public projectFilters: any[] = [{ id: "all", title: "전체 프로젝트" }, ...this.projects];

    private highschoolLegacyPath: string = "/assets/고교학점제/고교학점제 자료";

    private legacyHighschoolResources(): any[] {
        const root = "/assets/고교학점제";
        const legacy = this.highschoolLegacyPath;
        return [
            {
                id: "legacy-highschool-proposal-pdfs",
                type: "output",
                kind: "proposal",
                title: "고교학점제 기존 제안서 PDF",
                projectId: "highschool-credit",
                status: "보관",
                progress: 100,
                due: "보관",
                updated: "2026-05-17",
                created: "2026-05-17",
                owner: "김지원",
                tags: ["기존 자료", "제안서", "PDF"],
                summary: "기존 사이트에서 사용하던 고교학점제 제안서 PDF 원본과 0517 버전을 보관",
                description: "새 제안서 초안과 함께 대조할 수 있도록 기존 제안서 PDF 원본 파일을 유지한 마이그레이션 항목입니다.",
                cover: `${root}/proposal-preview.svg`,
                url: `${legacy}/고교학점제 제안서.pdf`,
                connectedIds: ["highschool-proposal", "highschool-presentation"],
                referenceIds: ["legacy-highschool-request", "legacy-highschool-requirements"],
                memo: "원본 PDF와 0517 버전을 함께 남겨 새 구조에서도 기존 제출본을 추적할 수 있게 했다.",
                links: [
                    { label: "제안서 PDF", url: `${legacy}/고교학점제 제안서.pdf` },
                    { label: "제안서 0517", url: `${legacy}/고교학점제 제안서_0517.pdf` },
                    { label: "웹 제안서", url: `${root}/proposal.html` },
                    { label: "편집 원문", url: `${root}/proposal.md` },
                ],
            },
            {
                id: "legacy-highschool-presentation-pdf",
                type: "output",
                kind: "presentation",
                title: "고교학점제 기존 발표자료 PDF",
                projectId: "highschool-credit",
                status: "보관",
                progress: 100,
                due: "보관",
                updated: "2026-05-17",
                created: "2026-05-17",
                owner: "김지원",
                tags: ["기존 자료", "발표자료", "PDF"],
                summary: "기존 사이트에 있던 고교학점제 발표자료 0517 PDF 원본",
                description: "웹 발표자료로 재구성하기 전의 원본 발표자료 PDF를 유지한 보관 항목입니다.",
                cover: `${root}/presentation-preview.svg`,
                url: `${legacy}/고교학점제 발표자료_0517.pdf`,
                connectedIds: ["highschool-presentation", "legacy-highschool-slide-samples"],
                referenceIds: ["legacy-highschool-presentation-design"],
                memo: "기존 PDF 발표본을 새 발표자료 항목과 연결해 비교 가능하게 보관했다.",
                links: [
                    { label: "발표자료 0517 PDF", url: `${legacy}/고교학점제 발표자료_0517.pdf` },
                    { label: "웹 발표자료", url: `${root}/presentation.html` },
                    { label: "발표 구성안", url: `${root}/presentation-outline.md` },
                ],
            },
            {
                id: "legacy-highschool-request",
                type: "reference",
                kind: "document",
                title: "고교학점제 제안요청서 원본",
                projectId: "highschool-credit",
                status: "보관",
                progress: 100,
                due: "보관",
                updated: "2026-05-17",
                created: "2026-05-17",
                owner: "김지원",
                tags: ["기존 자료", "요청서", "PDF"],
                summary: "제안 범위와 요구 맥락을 확인할 수 있는 기존 제안요청서 PDF",
                description: "제안서와 발표자료의 입력 자료로 쓰인 원본 제안요청서입니다.",
                cover: `${legacy}/image2.png`,
                url: `${legacy}/고교학점제 제안요청서.pdf`,
                connectedIds: ["highschool-proposal", "legacy-highschool-proposal-pdfs"],
                referenceIds: [],
                memo: "요청서 원본은 제안서 검토 시 기준 문서로 사용한다.",
                links: [{ label: "제안요청서 PDF", url: `${legacy}/고교학점제 제안요청서.pdf` }],
            },
            {
                id: "legacy-highschool-requirements",
                type: "reference",
                kind: "document",
                title: "고교학점제 요구사항 원본",
                projectId: "highschool-credit",
                status: "보관",
                progress: 100,
                due: "보관",
                updated: "2026-05-17",
                created: "2026-05-17",
                owner: "김지원",
                tags: ["기존 자료", "요구사항", "HWP"],
                summary: "고교학점제 요구사항 원본 문서의 PDF와 HWP 파일",
                description: "기존 자료 폴더에 있던 요구사항 파일을 PDF/HWP 버튼으로 함께 유지했습니다.",
                cover: `${legacy}/image.png`,
                url: `${legacy}/고교학점제 요구사항.pdf`,
                connectedIds: ["highschool-proposal", "legacy-highschool-request"],
                referenceIds: [],
                memo: "PDF와 HWP 원본을 같이 연결해 기존 파일 접근성을 유지했다.",
                links: [
                    { label: "요구사항 PDF", url: `${legacy}/고교학점제 요구사항.pdf` },
                    { label: "요구사항 HWP", url: `${legacy}/고교학점제 요구사항.hwp` },
                ],
            },
            {
                id: "legacy-highschool-writing-guide",
                type: "reference",
                kind: "document",
                title: "고교학점제 작성 요령 원본",
                projectId: "highschool-credit",
                status: "보관",
                progress: 100,
                due: "보관",
                updated: "2026-05-17",
                created: "2026-05-17",
                owner: "김지원",
                tags: ["기존 자료", "작성 요령", "HWP"],
                summary: "제안서 작성 기준을 정리한 기존 작성 요령 PDF와 HWP",
                description: "문서 작성 방향과 표현 기준을 확인하기 위한 기존 작성 요령 자료입니다.",
                cover: `${root}/policy-context-card-sample.png`,
                url: `${legacy}/고교학점제 작성 요령.pdf`,
                connectedIds: ["highschool-proposal", "legacy-highschool-presentation-design"],
                referenceIds: [],
                memo: "작성 요령 원본을 보관해 새 제안서 문장 검토 기준으로 연결했다.",
                links: [
                    { label: "작성 요령 PDF", url: `${legacy}/고교학점제 작성 요령.pdf` },
                    { label: "작성 요령 HWP", url: `${legacy}/고교학점제 작성 요령.hwp` },
                ],
            },
            {
                id: "legacy-highschool-mobile-captures",
                type: "reference",
                kind: "image",
                title: "고교학점제 모바일 화면 캡처",
                projectId: "highschool-credit",
                status: "보관",
                progress: 100,
                due: "보관",
                updated: "2026-05-17",
                created: "2026-05-17",
                owner: "김지원",
                tags: ["기존 자료", "화면 캡처", "이미지"],
                summary: "기존 고교학점제 모바일 화면과 챗봇 UI 캡처 이미지",
                description: "기존 사이트에서 사용하던 모바일 메인 화면, 메뉴, 챗봇 UI 시안을 유지한 이미지 자료입니다.",
                cover: `${legacy}/image2.png`,
                url: `${legacy}/image2.png`,
                connectedIds: ["highschool-presentation", "legacy-highschool-slide-samples"],
                referenceIds: [],
                memo: "기존 화면 톤과 정보 구조를 새 발표자료 시각 레퍼런스로 보관했다.",
                links: [
                    { label: "모바일 메인", url: `${legacy}/image2.png` },
                    { label: "챗봇 화면", url: `${legacy}/image.png` },
                ],
            },
            {
                id: "legacy-highschool-presentation-design",
                type: "reference",
                kind: "document",
                title: "고교학점제 발표자료 디자인 지침",
                projectId: "highschool-credit",
                status: "보관",
                progress: 100,
                due: "보관",
                updated: "2026-05-17",
                created: "2026-05-17",
                owner: "김지원",
                tags: ["기존 자료", "디자인", "발표자료"],
                summary: "기존 발표자료 작업에서 확정한 레이아웃, 폰트, 검증 기준",
                description: "발표자료를 수정할 때 적용해야 하는 기존 ReviewOps 디자인 지침 문서입니다.",
                cover: `${root}/presentation-preview.svg`,
                url: `${legacy}/reviewops-presentation-design.md`,
                connectedIds: ["highschool-presentation", "legacy-highschool-writing-guide"],
                referenceIds: [],
                memo: "디자인 기준 문서를 새 자료 구조의 참고자료로 분류했다.",
                links: [{ label: "디자인 지침", url: `${legacy}/reviewops-presentation-design.md` }],
            },
            {
                id: "legacy-highschool-system-diagrams",
                type: "reference",
                kind: "image",
                title: "고교학점제 운영 도식 자료",
                projectId: "highschool-credit",
                status: "보관",
                progress: 100,
                due: "보관",
                updated: "2026-05-15",
                created: "2026-05-15",
                owner: "김지원",
                tags: ["기존 자료", "도식", "SVG"],
                summary: "운영 흐름 맵과 회사 조직도 원본 SVG/PNG 시각 자료",
                description: "제안서와 발표자료에 연결되는 운영 흐름 도식, 조직도 이미지, 벡터 원본을 묶어 보관합니다.",
                cover: `${root}/company-org-chart.png`,
                url: `${root}/credit-system-map.svg`,
                connectedIds: ["highschool-proposal", "highschool-presentation"],
                referenceIds: [],
                memo: "이미지와 SVG 원본을 함께 유지해 재사용 가능한 시각 자료로 분류했다.",
                links: [
                    { label: "운영 흐름 SVG", url: `${root}/credit-system-map.svg` },
                    { label: "조직도 PNG", url: `${root}/company-org-chart.png` },
                    { label: "조직도 SVG", url: `${root}/company-org-chart.svg` },
                ],
            },
            {
                id: "legacy-highschool-slide-samples",
                type: "reference",
                kind: "image",
                title: "고교학점제 슬라이드 샘플 묶음",
                projectId: "highschool-credit",
                status: "보관",
                progress: 100,
                due: "보관",
                updated: "2026-05-15",
                created: "2026-05-15",
                owner: "김지원",
                tags: ["기존 자료", "슬라이드", "이미지"],
                summary: "정책 배경, 데이터 모델, 역량, 운영 지원, 마무리 가치 슬라이드 샘플",
                description: "발표자료 제작 과정에서 만든 슬라이드별 이미지 샘플을 한 항목으로 묶어 새 갤러리에서 찾을 수 있게 했습니다.",
                cover: `${root}/policy-context-card-sample.png`,
                url: `${root}/policy-context-card-sample.png`,
                connectedIds: ["highschool-presentation", "legacy-highschool-mobile-captures"],
                referenceIds: ["legacy-highschool-presentation-design"],
                memo: "샘플 이미지를 개별 파일 버튼으로 유지해 누락 없이 접근할 수 있다.",
                links: [
                    { label: "정책 배경", url: `${root}/policy-context-card-sample.png` },
                    { label: "정책 배경 Calm", url: `${root}/policy-context-card-sample-calm.png` },
                    { label: "데이터 모델", url: `${root}/data-model-slide-sample.png` },
                    { label: "회사 역량", url: `${root}/company-capability-slide-sample.png` },
                    { label: "운영 지원", url: `${root}/support-operation-slide-sample.png` },
                    { label: "마무리 가치", url: `${root}/closing-value-slide-sample.png` },
                    { label: "ReviewOps 변경 과정", url: `${root}/reviewops-change-process.png` },
                ],
            },
        ];
    }

    public workItems: any[] = [
        {
            id: "workroom-database",
            type: "project",
            kind: "document",
            title: "Sirius Workroom 카탈로그 개편",
            projectId: "sirius-workroom",
            status: "진행 중",
            progress: 68,
            due: "이번 주",
            updated: "오늘 09:40",
            owner: "김지원",
            tags: ["대시보드", "데이터베이스", "UX"],
            summary: "작업 상태, 관계, 결과물이 함께 보이는 개인 작업 카탈로그 개편",
            description: "작업물 목록을 프로젝트, 참고자료, 결과물, 체크리스트가 서로 연결되는 데이터베이스형 화면으로 정리합니다.",
            cover: "/assets/고교학점제/proposal-preview.svg",
            url: "",
            connectedIds: ["highschool-proposal", "monthly-seminar-slides", "heritage-render-reference"],
            referenceIds: ["highschool-notes", "heritage-render-reference"],
            memo: "카드형 보기 위에 데이터베이스 필드와 관계 탐색을 얹는 IA 작업",
            links: [],
        },
        {
            id: "northeast-history-bigdata-instructions",
            type: "output",
            kind: "document",
            title: "동북아역사재단 역사현안 빅데이터 구축 기능 구조도 및 작업 인스트럭션",
            projectId: "northeast-culture-history-foundation",
            status: "완료",
            progress: 100,
            due: "보관",
            updated: "오늘",
            owner: "김지원",
            tags: ["동북아역사재단", "기능 구조도", "인스트럭션", "태그 체계"],
            summary: "내부 사용을 1차 타깃으로 한 태그 체계, 기능 구조도, 단계별 구현 인스트럭션 문서",
            description: "동북아역사재단 자료 통합, 태그 검수, 지식그래프, 출처 기반 AI 질의응답, 보고서 보조 기능을 구현하기 위한 작업 기준 문서입니다.",
            cover: "",
            url: "/assets/동북아역사재단/동북아역사재단_역사현안_빅데이터_구축_기능구조도_및_작업인스트럭션.md",
            connectedIds: ["workroom-database"],
            referenceIds: [],
            memo: "첨부 피드백과 공식 사업 축을 반영해 내부 1차 구축 기준으로 정리한 문서. 동북아 프로젝트 탭에서 바로 내려받을 수 있게 연결한다.",
            links: [
                {
                    label: "Markdown 다운로드",
                    url: "/assets/동북아역사재단/동북아역사재단_역사현안_빅데이터_구축_기능구조도_및_작업인스트럭션.md",
                    download: "동북아역사재단_역사현안_빅데이터_구축_기능구조도_및_작업인스트럭션.md",
                },
            ],
        },
        {
            id: "highschool-proposal",
            type: "output",
            kind: "proposal",
            title: "고교학점제 운영 지원 제안서",
            projectId: "highschool-credit",
            status: "검토 필요",
            progress: 82,
            due: "5월 15일",
            updated: "오늘 08:20",
            owner: "김지원",
            tags: ["교육", "제안서", "초안"],
            summary: "진로·과목 선택 지원과 학점 이수 관리를 묶은 운영 지원 제안서 초안",
            description: "학생 선택, 교사 운영, 학부모 커뮤니케이션을 하나의 운영 지원 흐름으로 묶은 제안서입니다.",
            cover: "/assets/고교학점제/proposal-preview.svg",
            url: "/assets/고교학점제/proposal.html",
            connectedIds: ["highschool-presentation", "highschool-notes", "workroom-database"],
            referenceIds: ["highschool-notes"],
            memo: "정책 배경, 운영 흐름, 제안 범위를 하나의 제안서 초안으로 매핑",
            links: [
                { label: "제안서", url: "/assets/고교학점제/proposal.html" },
                { label: "원문", url: "/assets/고교학점제/proposal.md" },
                { label: "참고", url: "/assets/고교학점제/reference-notes.md" },
            ],
        },
        {
            id: "highschool-presentation",
            type: "output",
            kind: "presentation",
            title: "고교학점제 운영 지원 발표자료",
            projectId: "highschool-credit",
            status: "검토 필요",
            progress: 76,
            due: "5월 15일",
            updated: "어제 18:10",
            owner: "김지원",
            tags: ["교육", "발표자료", "11장"],
            summary: "학생·교사·학부모 흐름을 설명하는 11장 구성의 웹 발표자료",
            description: "제안서의 문제 정의와 운영 지원 흐름을 발표용 문장과 슬라이드 구조로 재구성한 자료입니다.",
            cover: "/assets/고교학점제/presentation-preview.svg",
            url: "/assets/고교학점제/presentation.html",
            connectedIds: ["highschool-proposal", "highschool-notes"],
            referenceIds: ["highschool-notes"],
            memo: "제안서의 문제 정의와 운영 구조를 발표 흐름으로 재구성",
            links: [
                { label: "발표자료", url: "/assets/고교학점제/presentation.html" },
                { label: "구성안", url: "/assets/고교학점제/presentation-outline.md" },
            ],
        },
        {
            id: "highschool-notes",
            type: "reference",
            kind: "memo",
            title: "고교학점제 정책·운영 참고 메모",
            projectId: "highschool-credit",
            status: "보관",
            progress: 100,
            due: "보관",
            updated: "5월 15일",
            owner: "김지원",
            tags: ["정책", "운영", "메모"],
            summary: "제안서와 발표자료에 연결된 정책·운영 참고 메모",
            description: "고교학점제 제안서와 발표자료에서 공통으로 참조하는 정책, 운영, 작성 방향 메모입니다.",
            cover: "",
            url: "/assets/고교학점제/reference-notes.md",
            connectedIds: ["highschool-proposal", "highschool-presentation"],
            memo: "고교학점제 제안서와 발표자료에 공통으로 연결되는 정책·운영 근거",
            links: [{ label: "메모", url: "/assets/고교학점제/reference-notes.md" }],
        },
        {
            id: "monthly-seminar-slides",
            type: "output",
            kind: "presentation",
            title: "Season Docs 월간 세미나 발표자료",
            projectId: "monthly-seminar",
            status: "완료",
            progress: 100,
            due: "완료",
            updated: "5월 3일",
            owner: "김지원",
            tags: ["세미나", "발표자료", "PDF"],
            summary: "Season Docs 개발 과정과 백석문화대 제안서 작업물을 소개하는 발표자료",
            description: "웹 발표자료, PDF, PPTX 파일을 함께 보관하는 내부 공유용 세미나 결과물입니다.",
            cover: "/assets/presentations/monthly-seminar/slide-01.png",
            url: "/assets/presentations/monthly-seminar/index.html",
            connectedIds: ["workroom-database"],
            memo: "웹, PDF, PPTX를 모두 결과물 첨부로 연결",
            links: [
                { label: "웹", url: "/assets/presentations/monthly-seminar/index.html" },
                { label: "PDF", url: "/assets/presentations/monthly-seminar/monthly-seminar-season-docs-proposal.pdf" },
                { label: "PPTX", url: "/assets/presentations/monthly-seminar/monthly-seminar-season-docs-proposal.pptx" },
            ],
        },
        {
            id: "heritage-classification-main",
            type: "output",
            kind: "image",
            title: "국가유산 유형분류 제안서 이미지",
            projectId: "heritage-proposal",
            status: "완료",
            progress: 100,
            due: "보관",
            updated: "5월 7일",
            owner: "김지원",
            tags: ["국가유산", "시각 자료", "제안서"],
            summary: "국가유산 유형분류를 제안서 본문에 바로 넣을 수 있도록 정리한 시각 자료",
            description: "국가유산 유형분류 체계를 제안서 본문 삽입에 맞춰 정리한 최종 이미지 결과물입니다.",
            cover: "/assets/proposals/heritage-classification/heritage-type-classification-proposal.png",
            url: "/assets/proposals/heritage-classification/heritage-type-classification-proposal.png",
            connectedIds: ["heritage-classification-basic", "heritage-render-reference"],
            referenceIds: ["heritage-classification-basic", "heritage-render-reference"],
            memo: "제안서 본문 삽입용 최종 이미지 결과물",
            links: [
                { label: "PNG", url: "/assets/proposals/heritage-classification/heritage-type-classification-proposal.png" },
                { label: "SVG", url: "/assets/proposals/heritage-classification/heritage-type-classification-proposal.svg" },
            ],
        },
        {
            id: "heritage-classification-basic",
            type: "reference",
            kind: "image",
            title: "국가유산 유형분류 기본 이미지",
            projectId: "heritage-proposal",
            status: "보관",
            progress: 100,
            due: "보관",
            updated: "5월 7일",
            owner: "김지원",
            tags: ["국가유산", "분류체계", "기본안"],
            summary: "상위 유형과 세부 항목을 한눈에 비교할 수 있게 만든 기본 분류표",
            description: "최종 제안서형 이미지의 기준이 되는 기본 분류표입니다.",
            cover: "/assets/proposals/heritage-classification/heritage-type-classification.png",
            url: "/assets/proposals/heritage-classification/heritage-type-classification.png",
            connectedIds: ["heritage-classification-main", "heritage-render-reference"],
            memo: "최종 제안서형 이미지의 기준이 되는 기본 분류표",
            links: [
                { label: "PNG", url: "/assets/proposals/heritage-classification/heritage-type-classification.png" },
                { label: "SVG", url: "/assets/proposals/heritage-classification/heritage-type-classification.svg" },
            ],
        },
        {
            id: "heritage-render-reference",
            type: "reference",
            kind: "image",
            title: "국가유산 제안서 렌더 샘플",
            projectId: "heritage-proposal",
            status: "보관",
            progress: 100,
            due: "보관",
            updated: "5월 7일",
            owner: "김지원",
            tags: ["국가유산", "렌더", "페이지 샘플"],
            summary: "제안서 실제 페이지에 들어갔을 때의 밀도와 배치를 확인하기 위한 렌더 샘플",
            description: "시각 자료가 실제 제안서 페이지에 들어갔을 때의 여백, 크기, 밀도를 확인하기 위한 렌더 샘플입니다.",
            cover: "/assets/proposals/heritage-classification/reference-renders/proposal-p03.png",
            url: "/assets/proposals/heritage-classification/reference-renders/proposal-p03.png",
            connectedIds: ["heritage-classification-main", "heritage-classification-basic"],
            memo: "실제 페이지 렌더에서 이미지 밀도와 여백을 점검한 참고자료",
            links: [
                { label: "P03", url: "/assets/proposals/heritage-classification/reference-renders/proposal-p03.png" },
                { label: "P04", url: "/assets/proposals/heritage-classification/reference-renders/proposal-p04.png" },
                { label: "P11", url: "/assets/proposals/heritage-classification/reference-renders/proposal-p11.png" },
                { label: "P21", url: "/assets/proposals/heritage-classification/reference-renders/proposal-p21.png" },
            ],
        },
        {
            id: "automation-proposal-draft",
            type: "work",
            kind: "proposal",
            title: "AI 업무 자동화 제안서 초안",
            projectId: "sirius-workroom",
            status: "진행 중",
            progress: 54,
            due: "5월 8일",
            updated: "오늘 11:00",
            owner: "김지원",
            tags: ["자동화", "제안서", "초안"],
            summary: "고객 문제 정의와 자동화 도입 효과를 제안서 초안으로 정리하는 작업",
            description: "고객 문제 정의, 자동화 적용 범위, 기대 효과를 제안서 초안으로 정리하는 진행 중 작업입니다.",
            cover: "",
            url: "",
            connectedIds: ["workroom-database"],
            links: [],
        },
        {
            id: "weekly-minutes",
            type: "note",
            kind: "memo",
            title: "운영 주간 회의록 정리",
            projectId: "sirius-workroom",
            status: "검토 필요",
            progress: 72,
            due: "오늘 17:00",
            updated: "오늘 10:30",
            owner: "김지원",
            tags: ["회의록", "액션 아이템", "운영"],
            summary: "결정 사항과 액션 아이템을 공유 가능한 회의록으로 정리",
            description: "결정 사항, 담당자, 후속 액션 아이템을 공유 가능한 회의록으로 정리하는 문서 작업입니다.",
            cover: "",
            url: "",
            connectedIds: ["workroom-database"],
            memo: "결정 사항과 액션 아이템을 체크리스트로 관리",
            links: [],
        },
    ];

    constructor(@Inject( Service) public service: Service) { }

    private async renderView() {
        await this.service.sleep(0);
        await this.service.render();
    }

    public async ngOnInit() {
        await this.service.init();
        this.loadStatusOverrides();
        this.loadQuickData();
        this.refreshProjectFilters();
        this.applyInitialFilter();
        await this.loadWorkTasks();
        await this.syncLocalQuickDataToServer();
        this.mergeTaskProjects();
        this.refreshDateFilters();
        this.selectedItem = this.filteredItems[0] || this.allItems[0] || null;
        await this.renderView();
    }

    @HostListener('window:sirius-dashboard-search', ['$event'])
    public async handleHeaderSearch(event: any) {
        this.searchText = event?.detail?.query || "";
        this.keepSelectedVisible();
        await this.renderView();
    }

    @HostListener('window:sirius-dashboard-quick-add', ['$event'])
    public async handleHeaderQuickAdd(event: any) {
        await this.openQuickAdd(event?.detail?.type || "work");
    }

    public get allItems(): any[] {
        const baseItems = [...this.workItems, ...this.legacyHighschoolResources()].map((item) => this.normalizeItem(item));
        const baseTitles = baseItems.map((item) => item.title);
        const taskItems = this.taskRows
            .filter((task) => !baseTitles.includes(this.normalizeTitle(task.title || task.result_title || "")))
            .map((task) => this.normalizeItem(this.taskToItem(task)));
        const localItems = this.localQuickItems
            .filter((item) => !this.isLocalItemBackedByTask(item))
            .filter((item) => !baseTitles.includes(this.normalizeTitle(item.title || "")))
            .map((item) => this.normalizeItem(item));
        return [...baseItems, ...taskItems, ...localItems];
    }

    public get filteredItems(): any[] {
        const query = this.searchText.trim().toLowerCase();
        const filtered = this.allItems.filter((item) => {
            if (this.activeProject !== "all" && item.projectId !== this.activeProject) return false;
            if (this.activeType !== "all" && item.type !== this.activeType) return false;
            if (this.activeKind !== "all" && item.kind !== this.activeKind) return false;
            if (this.activeStatus !== "all" && item.status !== this.activeStatus) return false;
            if (this.activeTag !== "all" && !(item.tags || []).includes(this.activeTag)) return false;
            if (this.activeDate !== "all" && !this.matchesDateFilter(item, this.activeDate)) return false;
            if (!query) return true;

            return this.itemSearchText(item).indexOf(query) >= 0;
        });
        return this.sortItems(filtered);
    }

    public get metricCards(): any[] {
        return this.statusSummary.slice(0, 4);
    }

    public get statusSummary(): any[] {
        const all = this.allItems;
        const captions: any = {
            "초안": "새로 잡힌 항목",
            "진행 중": "오늘 이어갈 일",
            "검토 필요": "확인 대기",
            "완료": "결과물 정리",
            "보관": "아카이브",
        };

        return this.statusFilters
            .filter((status) => status.key !== "all")
            .map((status) => ({
                ...status,
                value: all.filter((item) => item.status === status.key).length,
                caption: captions[status.key] || "상태 항목",
            }));
    }

    public get databaseUnits(): any[] {
        const all = this.allItems;
        return [
            { key: "work", label: "작업물", value: all.filter((item) => item.type === "work").length, caption: "진행 항목" },
            { key: "project", label: "프로젝트", value: this.projects.length, caption: "상위 묶음" },
            { key: "all", label: "태그", value: this.visibleTags.length, caption: "분류 키" },
            { key: "reference", label: "참고자료", value: all.filter((item) => item.type === "reference").length, caption: "근거 자료" },
            { key: "output", label: "결과물", value: all.filter((item) => item.type === "output").length, caption: "첨부 연결" },
            { key: "note", label: "체크리스트/메모", value: all.filter((item) => item.type === "note" || !!item.memo).length, caption: "관리 기록" },
        ];
    }

    public get catalogIntroText(): string {
        const activeCount = this.allItems.filter((item) => ["초안", "진행 중", "검토 필요"].includes(item.status)).length;
        const doneCount = this.allItems.filter((item) => item.type === "output" && (item.status === "완료" || item.status === "보관")).length;
        const projectCount = this.projectCards.length;
        return `오늘은 ${activeCount}개의 진행 항목을 이어보고, ${doneCount}개의 완료 결과물을 다시 꺼내볼 수 있습니다. 작업물은 ${projectCount}개 프로젝트와 태그 기준으로 조용히 정리되어 있습니다.`;
    }

    public get visibleTags(): string[] {
        const tags: string[] = [];
        this.allItems.forEach((item) => {
            (item.tags || []).forEach((tag: string) => {
                if (!tags.includes(tag)) tags.push(tag);
            });
        });
        return tags.sort();
    }

    public get recentItems(): any[] {
        return this.filteredItems.slice(0, 5);
    }

    public get activeDashboardItems(): any[] {
        return this.filteredItems
            .filter((item) => ["초안", "진행 중", "검토 필요"].includes(item.status))
            .slice(0, 5);
    }

    public get completedOutputItems(): any[] {
        return this.filteredItems
            .filter((item) => item.type === "output" && (item.status === "완료" || item.status === "보관"))
            .slice(0, 4);
    }

    public get tagShortcuts(): any[] {
        const counts: any = {};
        this.allItems.forEach((item) => {
            (item.tags || []).forEach((tag: string) => {
                counts[tag] = (counts[tag] || 0) + 1;
            });
        });

        return Object.keys(counts)
            .sort((a, b) => counts[b] - counts[a] || a.localeCompare(b))
            .slice(0, 14)
            .map((tag) => ({ label: tag, count: counts[tag] }));
    }

    public get quickAddButtons(): any[] {
        return [
            { type: "work", label: "새 작업물 추가", caption: "초안부터" },
            { type: "project", label: "새 프로젝트 추가", caption: "묶음 생성" },
            { type: "reference", label: "참고자료 추가", caption: "링크 보관" },
            { type: "output", label: "결과물 등록", caption: "완성본 연결" },
        ];
    }

    public get dueItems(): any[] {
        return this.allItems.filter((item) => item.status !== "완료" && item.status !== "보관").slice(0, 5);
    }

    public get boardColumns(): any[] {
        return this.statusFilters
            .filter((status) => status.key !== "all")
            .map((status) => ({
                key: status.key,
                label: status.label,
                items: this.filteredItems.filter((item) => item.status === status.key),
            }));
    }

    public get projectViewCards(): any[] {
        return this.projects
            .map((project) => {
                const items = this.filteredItems.filter((item) => item.projectId === project.id);
                const done = items.filter((item) => item.status === "완료" || item.status === "보관").length;
                const activeCount = items.filter((item) => ["초안", "진행 중", "검토 필요"].includes(item.status)).length;
                const tagMap: any = {};
                items.forEach((item) => (item.tags || []).forEach((tag: string) => tagMap[tag] = (tagMap[tag] || 0) + 1));
                const tags = Object.keys(tagMap)
                    .sort((a, b) => tagMap[b] - tagMap[a] || a.localeCompare(b))
                    .slice(0, 6);
                const progress = items.length ? Math.round((done / items.length) * 100) : 0;
                return { ...project, items, progress, activeCount, doneCount: done, tags };
            })
            .filter((project) => project.items.length > 0);
    }

    public get projectCards(): any[] {
        return this.projects.map((project) => {
            const items = this.allItems.filter((item) => item.projectId === project.id);
            const done = items.filter((item) => item.status === "완료" || item.status === "보관").length;
            const activeCount = items.filter((item) => ["초안", "진행 중", "검토 필요"].includes(item.status)).length;
            const outputCount = items.filter((item) => item.type === "output").length;
            const progress = items.length ? Math.round((done / items.length) * 100) : 0;
            return { ...project, items, progress, activeCount, outputCount, doneCount: done };
        });
    }

    public get connectedItems(): any[] {
        if (!this.selectedItem) return [];
        const ids = this.selectedItem.relatedIds || this.selectedItem.connectedIds || [];
        return this.allItems.filter((item) => ids.includes(item.id));
    }

    public get referenceItems(): any[] {
        if (!this.selectedItem) return [];
        const ids = this.selectedItem.referenceIds || [];
        return this.allItems.filter((item) => ids.includes(item.id));
    }

    public get selectedAttachments(): any[] {
        if (!this.selectedItem) return [];
        if (this.selectedItem.attachments && this.selectedItem.attachments.length) return this.selectedItem.attachments;
        return this.selectedItem.links || [];
    }

    public get selectedFailedResource(): any {
        if (!this.selectedItem) return null;
        if (this.selectedItem.url && this.resourceFailures[this.selectedItem.url]) {
            return { label: "대표 파일", url: this.selectedItem.url };
        }
        return this.selectedAttachments.find((link) => link?.url && this.resourceFailures[link.url]) || null;
    }

    public get selectedChecklist(): any[] {
        if (!this.selectedItem) return [];
        return this.selectedItem.checklist || [];
    }

    public get currentFocusLabel(): string {
        if (this.activeKind !== "all") return `${this.kindLabel(this.activeKind)} 작업 보기`;
        if (this.activeType !== "all") return `${this.typeLabel(this.activeType)} 보기`;
        return "전체 작업물 카탈로그";
    }

    public get pageTitle(): string {
        if (this.activeKind !== "all") return `${this.kindLabel(this.activeKind)} 작업 공간`;
        if (this.activeType !== "all") return `${this.typeLabel(this.activeType)} 작업 공간`;
        return "개인 작업물 카탈로그";
    }

    public get pageDescription(): string {
        if (this.activeKind === "presentation") return "발표 흐름, 참고자료, 완성본을 한 화면에서 비교하며 정리합니다.";
        if (this.activeKind === "proposal") return "제안서 초안, 검토 상태, 관련 발표자료를 연결해 관리합니다.";
        if (this.activeKind === "document") return "문서와 회의록을 프로젝트별 맥락 안에서 정돈합니다.";
        if (this.activeType === "reference") return "결과물에 연결할 메모, 링크, 이미지 자료를 보관합니다.";
        if (this.activeType === "output") return "완료된 산출물과 첨부 파일을 다시 찾기 쉬운 형태로 모읍니다.";
        return "최근 작업, 진행 중인 일, 완료된 결과물을 프로젝트와 태그로 다시 찾는 개인 작업 공간";
    }

    public get activeFilterCount(): number {
        return [
            this.activeType !== "all",
            this.activeKind !== "all",
            this.activeStatus !== "all",
            this.activeTag !== "all",
            this.activeProject !== "all",
            this.activeDate !== "all",
            !!this.searchText.trim(),
        ].filter((active) => active).length;
    }

    public get hasActiveFilters(): boolean {
        return this.activeFilterCount > 0;
    }

    public get emptyStateTitle(): string {
        if (this.searchText.trim()) return "검색 결과가 없습니다";
        if (this.activeType === "reference") return "참고자료가 없습니다";
        if (this.activeType === "project") return "프로젝트가 없습니다";
        if (this.hasActiveFilters) return "조건에 맞는 항목이 없습니다";
        return "아직 작업물이 없습니다";
    }

    public get emptyStateDescription(): string {
        if (this.searchText.trim()) return "검색어를 줄이거나 필터를 초기화하세요.";
        if (this.activeType === "reference") return "메모와 링크를 참고자료로 남겨두세요.";
        if (this.activeType === "project") return "작업물을 묶을 프로젝트를 먼저 만드세요.";
        if (this.hasActiveFilters) return "필터를 줄이면 더 많은 항목이 보입니다.";
        return "첫 작업물을 추가해 흐름을 만들 수 있습니다.";
    }

    public get emptyStateActionLabel(): string {
        if (this.searchText.trim()) return "필터 초기화";
        if (this.activeType === "reference") return "참고자료 추가";
        if (this.activeType === "project") return "프로젝트 만들기";
        if (this.hasActiveFilters) return "필터 초기화";
        return "작업물 추가";
    }

    public get projectEmptyTitle(): string {
        if (this.projects.length === 0) return "프로젝트가 없습니다";
        return "조건에 맞는 프로젝트가 없습니다";
    }

    public get projectEmptyDescription(): string {
        if (this.projects.length === 0) return "새 프로젝트로 작업물과 참고자료를 묶으세요.";
        return "프로젝트 필터를 줄이거나 프로젝트를 추가하세요.";
    }

    public get projectEmptyActionLabel(): string {
        if (this.hasActiveFilters) return "필터 초기화";
        return "프로젝트 만들기";
    }

    public get quickPanelTitle(): string {
        const action = this.quickAddButtons.find((item) => item.type === this.quickForm.type);
        return action ? action.label : "새 작업물 추가";
    }

    public get quickSaveLabel(): string {
        if (this.quickForm.type === "output") return "결과물 등록";
        return "저장";
    }

    public async setView(view: string) {
        if (!this.viewModes.some((mode) => mode.key === view)) return;
        this.activeView = view;
        await this.renderView();
    }

    public async setType(type: string) {
        this.activeType = type;
        this.updateUrlState();
        this.keepSelectedVisible();
        await this.renderView();
    }

    public async setKind(kind: string) {
        this.activeKind = kind;
        this.updateUrlState();
        this.keepSelectedVisible();
        await this.renderView();
    }

    public async setStatus(status: string) {
        this.activeStatus = status;
        this.keepSelectedVisible();
        await this.renderView();
    }

    public async setProject(projectId: string) {
        this.activeProject = projectId;
        if (projectId !== "all") this.exportProjectId = projectId;
        this.keepSelectedVisible();
        await this.renderView();
    }

    public async setDate(date: string) {
        this.activeDate = date;
        this.keepSelectedVisible();
        await this.renderView();
    }

    public async setSort(sort: string) {
        this.activeSort = sort;
        this.keepSelectedVisible();
        await this.renderView();
    }

    public async setTag(tag: string) {
        this.activeTag = this.activeTag === tag ? "all" : tag;
        this.keepSelectedVisible();
        await this.renderView();
    }

    public async searchAction() {
        this.keepSelectedVisible();
        await this.renderView();
    }

    public async clearFilters() {
        this.activeType = "all";
        this.activeKind = "all";
        this.activeStatus = "all";
        this.activeTag = "all";
        this.activeProject = "all";
        this.activeDate = "all";
        this.searchText = "";
        this.updateUrlState();
        this.keepSelectedVisible();
        await this.renderView();
    }

    public async runEmptyPrimaryAction() {
        if (this.searchText.trim()) {
            await this.clearFilters();
            return;
        }
        if (this.activeType === "reference") {
            await this.openQuickAdd("reference");
            return;
        }
        if (this.activeType === "project" || this.activeView === "project") {
            await this.openQuickAdd("project");
            return;
        }
        if (this.hasActiveFilters) {
            await this.clearFilters();
            return;
        }
        await this.openQuickAdd("work");
    }

    public async runProjectEmptyAction() {
        if (this.hasActiveFilters) {
            await this.clearFilters();
            return;
        }
        await this.openQuickAdd("project");
    }

    public async runReferenceEmptyAction() {
        await this.openQuickAdd("reference");
    }

    public async reloadWorkTasks() {
        await this.loadWorkTasks();
        await this.syncLocalQuickDataToServer();
        this.mergeTaskProjects();
        this.refreshDateFilters();
        this.keepSelectedVisible();
        await this.renderView();
    }

    public async selectItem(item: any) {
        this.selectedItem = item;
        await this.renderView();
    }

    public openItem(item: any) {
        if (!item) return;
        const normalized = this.normalizeItem(item);
        this.selectedItem = normalized;
        try {
            sessionStorage.setItem("workroom-selected-item", JSON.stringify(normalized));
        } catch (e) {
            // Detail page has a static fallback for known work items.
        }
        this.service.href(`/work/${encodeURIComponent(normalized.id)}`);
    }

    public async changeItemStatus(item: any, status: string, event?: Event) {
        if (event) event.stopPropagation();
        const nextStatus = this.normalizeStatus(status);
        const nextProgress = this.statusProgress(nextStatus);
        const taskId = item.sourceTaskId || (item.id || "").replace(/^task-/, "");
        const source = this.workItems.find((row) => row.id === item.id);

        if (taskId && this.taskRows.some((row) => `${row.id}` === `${taskId}`)) {
            const updatedItem = this.normalizeItem({ ...item, status: nextStatus, progress: nextProgress, updated: "방금" });
            try {
                const response = await wiz.call("update_task", {
                    id: taskId,
                    data: JSON.stringify(this.taskPayloadFromItem(updatedItem)),
                });
                if (response.code !== 200) throw new Error(response.data?.message || "저장에 실패했습니다.");
                this.replaceTaskRow(response.data.task);
                delete this.statusOverrides[item.id];
                this.saveStatusOverrides();
            } catch (e) {
                this.taskLoadFailed = true;
                this.taskLoadMessage = "상태 변경을 저장하지 못했습니다. 잠시 후 다시 시도하세요.";
            }
        } else if (source) {
            this.statusOverrides[item.id] = nextStatus;
            this.saveStatusOverrides();
            source.status = nextStatus;
            source.progress = nextProgress;
            source.updated = "방금";
            source.checklist = this.defaultChecklist(source, nextStatus);
        } else {
            item.status = nextStatus;
            item.progress = nextProgress;
            item.updated = "방금";
            item.checklist = this.defaultChecklist(item, nextStatus);
        }

        const updated = this.allItems.find((entry) => entry.id === item.id) || this.normalizeItem({ ...item, status: nextStatus, progress: nextProgress });
        if (!this.selectedItem || this.selectedItem.id === item.id) {
            this.selectedItem = updated;
        }
        this.keepSelectedVisible();
        await this.renderView();
    }

    public canDeleteItem(item: any): boolean {
        if (!item) return false;
        return !!item.sourceTaskId || `${item.id || ""}`.indexOf("local-") === 0;
    }

    public async deleteItem(item: any, event?: Event) {
        if (event) event.stopPropagation();
        if (!this.canDeleteItem(item)) return;
        if (!window.confirm("이 작업물을 삭제할까요?")) return;

        this.deletingItem = true;
        const taskId = item.sourceTaskId || (item.id || "").replace(/^task-/, "");
        try {
            if (taskId && this.taskRows.some((row) => `${row.id}` === `${taskId}`)) {
                const response = await wiz.call("delete_task", { id: taskId });
                if (response.code !== 200) throw new Error(response.data?.message || "삭제에 실패했습니다.");
                this.taskRows = this.taskRows.filter((row) => `${row.id}` !== `${taskId}`);
            } else {
                this.localQuickItems = this.localQuickItems.filter((row) => row.id !== item.id);
                this.saveLegacyQuickData();
            }
            delete this.statusOverrides[item.id];
            this.saveStatusOverrides();
            this.mergeTaskProjects();
            this.refreshDateFilters();
            this.selectedItem = this.filteredItems[0] || this.allItems[0] || null;
            this.keepSelectedVisible();
        } catch (e) {
            this.taskLoadFailed = true;
            this.taskLoadMessage = "작업물을 삭제하지 못했습니다. 잠시 후 다시 시도하세요.";
        }
        this.deletingItem = false;
        await this.renderView();
    }

    public async setQuickType(type: string) {
        const defaults = this.quickDefaults(type);
        this.quickNotice = "";
        this.quickSaveFailed = false;
        this.quickForm = {
            ...this.quickForm,
            type,
            kind: defaults.kind,
            status: defaults.status,
            projectId: this.quickForm.projectId || this.defaultProjectId(),
            linkLabel: this.quickForm.linkLabel || defaults.linkLabel,
        };
        await this.renderView();
    }

    public async openQuickAdd(type: string = "work") {
        this.quickPanelOpen = true;
        this.quickNotice = "";
        this.quickSaveFailed = false;
        this.quickForm = this.createQuickForm(type);
        await this.renderView();
    }

    public async closeQuickAdd() {
        this.quickPanelOpen = false;
        this.quickNotice = "";
        this.quickSaveFailed = false;
        await this.renderView();
    }

    public async submitQuickAdd() {
        const title = this.compactText(this.quickForm.title);
        if (!title) {
            this.quickNotice = "제목을 입력해주세요.";
            this.quickSaveFailed = false;
            await this.renderView();
            return;
        }

        this.savingQuick = true;
        this.quickNotice = "";
        this.quickSaveFailed = false;
        await this.renderView();

        const tags = this.parseTags(this.quickForm.tags);
        const summary = this.compactText(this.quickForm.summary) || "상세 페이지에서 내용을 이어서 정리하세요.";
        const reference = this.compactText(this.quickForm.reference);
        const checklist = this.parseChecklist(this.quickForm.checklist);
        const linkUrl = this.compactText(this.quickForm.linkUrl);
        const linkLabel = this.compactText(this.quickForm.linkLabel) || this.typeLabel(this.quickForm.type);
        const links = linkUrl ? [{ label: linkLabel, url: linkUrl }] : [];
        let project = this.projectById(this.quickForm.projectId);
        let createdProject: any = null;

        if (this.quickForm.type === "project") {
            createdProject = {
                id: this.makeLocalId("project", title),
                title,
                status: this.quickForm.status,
                owner: "김지원",
                summary,
            };
            project = createdProject;
        }

        const item = {
            id: `local-${this.service.random(8)}`,
            sourceTaskId: "",
            type: this.quickForm.type,
            kind: this.quickForm.kind,
            title,
            projectId: project.id,
            projectName: project.title,
            status: this.quickForm.status,
            progress: this.statusProgress(this.quickForm.status),
            date: this.quickForm.due || "날짜 미정",
            due: this.quickForm.due || "날짜 미정",
            updated: "방금",
            owner: "김지원",
            tags: tags.length ? tags : [this.kindLabel(this.quickForm.kind)],
            description: summary,
            summary,
            thumbnail: "",
            cover: "",
            url: linkUrl,
            relatedIds: this.selectedItem?.id ? [this.selectedItem.id] : [],
            connectedIds: this.selectedItem?.id ? [this.selectedItem.id] : [],
            referenceIds: [],
            attachments: links,
            links,
            memo: reference,
            checklist: checklist.length ? checklist : this.defaultChecklist({ title, summary, projectId: project.id, tags, links }, this.quickForm.status),
            kindLabel: this.kindLabel(this.quickForm.kind),
            typeLabel: this.typeLabel(this.quickForm.type),
        };

        const payload = {
            ...this.taskPayloadFromItem(item),
            reference: this.composeQuickReference(reference, tags, linkUrl, checklist),
        };

        let response: any = {};
        try {
            response = await wiz.call("create_task", { data: JSON.stringify(payload) });
        } catch (error) {
            response = { code: 500, data: { message: "저장에 실패했습니다. 네트워크 상태를 확인하고 다시 시도하세요." } };
        }

        const { code, data } = response;
        this.savingQuick = false;

        if (code === 200) {
            const savedTask = data?.task || {};
            this.replaceTaskRow(savedTask);
            this.mergeTaskProjects();
            const savedItem = this.normalizeItem(this.taskToItem(savedTask));
            this.refreshDateFilters();
            this.selectedItem = savedItem;
            this.quickPanelOpen = false;
            this.quickNotice = "";
            this.activeType = savedItem.type;
            this.activeKind = "all";
            this.activeStatus = "all";
            this.activeTag = "all";
            this.activeProject = "all";
            this.searchText = "";
            this.updateUrlState();
        } else {
            this.quickSaveFailed = true;
            this.quickNotice = data?.message || "저장에 실패했습니다. 잠시 후 다시 시도하세요.";
        }

        await this.renderView();
    }

    public viewButtonClass(view: string): string {
        const base = "inline-flex min-h-11 w-full items-center justify-center rounded-md px-3 text-center text-[13px] font-semibold leading-4 transition sm:h-8 sm:min-h-0 sm:w-auto sm:px-2.5";
        if (this.activeView === view) return `${base} bg-white text-zinc-950 shadow-sm ring-1 ring-zinc-200`;
        return `${base} text-zinc-500 hover:bg-white/70 hover:text-zinc-950`;
    }

    public filterButtonClass(active: string, key: string): string {
        const base = "inline-flex min-h-11 w-full items-center justify-center rounded-md border px-3 text-center text-xs font-semibold leading-4 transition sm:h-8 sm:min-h-0 sm:w-auto sm:px-2.5";
        if (active === key) return `${base} border-zinc-300 bg-zinc-950 text-white shadow-sm`;
        return `${base} border-zinc-200 bg-white text-zinc-600 hover:border-zinc-300 hover:bg-zinc-50 hover:text-zinc-950`;
    }

    public quickActionClass(type: string): string {
        const base = "wr-quick-type-option flex min-h-14 flex-col items-start justify-center rounded-md border px-3 py-2 text-left transition";
        if (this.quickForm.type === type) return `${base} border-zinc-950 bg-zinc-50 text-zinc-950`;
        return `${base} border-zinc-200 bg-white text-zinc-600 hover:border-zinc-300 hover:bg-zinc-50 hover:text-zinc-950`;
    }

    public trackById(index: number, item: any): any {
        return item?.id || item?.key || item?.label || item?.title || index;
    }

    public trackByKey(index: number, item: any): any {
        return item?.key || item?.id || item?.label || index;
    }

    public trackByType(index: number, item: any): any {
        return item?.type || item?.key || index;
    }

    public trackByLabel(index: number, item: any): any {
        return item?.label || item?.id || item?.url || index;
    }

    public trackByUrl(index: number, item: any): any {
        return item?.url || item?.label || index;
    }

    public trackByValue(index: number, item: any): any {
        return item || index;
    }

    public statusTone(status: string): string {
        const normalized = this.normalizeStatus(status || "");
        if (normalized === "완료") return "wr-status wr-status-done";
        if (normalized === "진행 중") return "wr-status wr-status-progress";
        if (normalized === "검토 필요") return "wr-status wr-status-review";
        if (normalized === "보관") return "wr-status wr-status-archive";
        return "wr-status wr-status-draft";
    }

    public typeTone(type: string): string {
        if (type === "project") return "wr-chip wr-type-project";
        if (type === "work") return "wr-chip wr-type-work";
        if (type === "reference") return "wr-chip wr-type-reference";
        if (type === "output") return "wr-chip wr-type-output";
        if (type === "note") return "wr-chip wr-type-note";
        return "wr-chip wr-type-etc";
    }

    public kindTone(kind: string): string {
        const normalized = this.normalizeKind(kind);
        if (normalized === "presentation") return "wr-chip wr-kind-presentation";
        if (normalized === "proposal") return "wr-chip wr-kind-proposal";
        if (normalized === "document") return "wr-chip wr-kind-document";
        if (normalized === "image") return "wr-chip wr-kind-image";
        if (normalized === "link") return "wr-chip wr-kind-link";
        if (normalized === "memo") return "wr-chip wr-kind-memo";
        return "wr-chip wr-kind-etc";
    }

    public tagTone(tag: string, active: boolean = false): string {
        const base = "wr-tag inline-flex max-w-full items-center rounded-md px-2 py-1 text-[11px] font-semibold leading-4 transition break-words";
        if (active) return `${base} wr-tag-active`;

        const seed = `${tag || ""}`.split("").reduce((sum, char) => sum + char.charCodeAt(0), 0);
        return `${base} wr-tag-tone-${seed % 5}`;
    }

    public typeLabel(type: string): string {
        const found = this.contentTypes.find((item) => item.key === type);
        return found ? found.label : "작업물";
    }

    public kindLabel(kind: string): string {
        const normalized = this.normalizeKind(kind);
        const found = this.kindFilters.find((item) => item.key === normalized);
        return found ? found.label.replace("전체 유형", "전체") : "기타";
    }

    public projectById(id: string): any {
        return this.projects.find((project) => project.id === id) || this.projects[0] || this.fallbackProject();
    }

    public itemProject(item: any): any {
        return this.projectById(item.projectId);
    }

    public hasLinks(item: any): boolean {
        return !!(item.url || (item.links && item.links.length) || (item.attachments && item.attachments.length));
    }

    public isMediaFailed(url: string): boolean {
        return !!(url && this.mediaFailures[url]);
    }

    public async markMediaFailed(url: string, event?: Event) {
        if (event) event.stopPropagation();
        if (!url) return;
        this.mediaFailures[url] = true;
        await this.renderView();
    }

    public async retryMedia(url: string, event?: Event) {
        if (event) event.stopPropagation();
        if (!url) return;
        delete this.mediaFailures[url];
        await this.renderView();
    }

    public async openResource(url: string, downloadName?: string) {
        if (!url) return;
        delete this.resourceFailures[url];

        try {
            if (this.shouldPreflightResource(url)) {
                const response = await fetch(url, { method: "HEAD", cache: "no-store" });
                if (!response.ok) throw new Error(`${response.status}`);
            }
            if (downloadName) {
                const link = document.createElement("a");
                link.href = url;
                link.download = downloadName;
                link.rel = "noopener";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                return;
            }
            window.open(url, "_blank", "noopener");
        } catch (error) {
            this.resourceFailures[url] = true;
            await this.renderView();
        }
    }

    public checklistDoneCount(item: any): number {
        return (item?.checklist || []).filter((entry: any) => !!entry.done).length;
    }

    public downloadPresentation(type: string) {
        const form = document.createElement("form");
        form.method = "POST";
        form.action = "/wiz/api/page.dashboard/download";
        form.style.display = "none";

        const input = document.createElement("input");
        input.type = "hidden";
        input.name = "type";
        input.value = type;
        form.appendChild(input);

        document.body.appendChild(form);
        form.submit();
        window.setTimeout(() => form.remove(), 1000);
    }

    public exportAllJson() {
        const snapshot = this.createExportSnapshot("all");
        this.downloadJson(snapshot, this.exportFilename("all"));
    }

    public exportProjectJson(projectId: string = "", event?: Event) {
        if (event) event.stopPropagation();
        const targetProjectId = projectId || this.exportProjectId;
        if (!targetProjectId || targetProjectId === "all") return;

        const project = this.projectById(targetProjectId);
        const snapshot = this.createExportSnapshot("project", project.id);
        this.downloadJson(snapshot, this.exportFilename("project", project.id));
    }

    private applyInitialFilter() {
        const params = new URLSearchParams(location.search);
        const tab = params.get("tab") || "";
        const query = params.get("q") || "";
        const quick = params.get("quick") || "";
        if (query) this.searchText = query;
        if (quick && this.quickAddButtons.some((item) => item.type === quick)) {
            this.quickPanelOpen = true;
            this.quickNotice = "";
            this.quickSaveFailed = false;
            this.quickForm = this.createQuickForm(quick);
        }
        if (tab === "project") {
            this.activeView = "project";
            this.activeType = "all";
            return;
        }
        if (this.contentTypes.some((item) => item.key === tab)) {
            this.activeType = tab;
            return;
        }
        if (this.kindFilters.some((item) => item.key === tab)) {
            this.activeKind = tab;
        }
    }

    private updateUrlState() {
        if (location.pathname.indexOf("/dashboard") !== 0) return;
        let tab = "";
        if (this.activeType !== "all") tab = this.activeType;
        else if (this.activeKind !== "all") tab = this.activeKind;
        const nextUrl = tab ? `/dashboard?tab=${tab}` : "/dashboard";
        history.replaceState({}, "", nextUrl);
    }

    private keepSelectedVisible() {
        if (this.selectedItem && this.filteredItems.some((item) => item.id === this.selectedItem.id)) return;
        this.selectedItem = this.filteredItems[0] || null;
    }

    private loadStatusOverrides() {
        try {
            this.statusOverrides = JSON.parse(localStorage.getItem("workroom-status-overrides") || "{}");
        } catch (e) {
            this.statusOverrides = {};
        }
    }

    private saveStatusOverrides() {
        try {
            localStorage.setItem("workroom-status-overrides", JSON.stringify(this.statusOverrides));
        } catch (e) {
            return;
        }
    }

    private loadQuickData() {
        try {
            const projects = JSON.parse(localStorage.getItem("workroom-quick-projects") || "[]");
            const items = JSON.parse(localStorage.getItem("workroom-quick-items") || "[]");
            if (Array.isArray(projects)) {
                this.localQuickProjects = projects
                    .filter((project: any) => !!project?.id)
                    .map((project: any) => ({ ...project, title: this.normalizeProjectTitle(project.title) }));
                this.localQuickProjects.slice().reverse().forEach((project: any) => {
                    if (project?.id && !this.projects.some((row) => row.id === project.id)) {
                        this.projects = [project, ...this.projects];
                    }
                });
            }
            if (Array.isArray(items)) {
                const knownIds = this.workItems.map((item) => item.id);
                this.localQuickItems = items.filter((item: any) => item?.id && !knownIds.includes(item.id));
            }
        } catch (e) {
            this.localQuickItems = [];
            this.localQuickProjects = [];
            return;
        }
    }

    private saveLegacyQuickData() {
        try {
            localStorage.setItem("workroom-quick-projects", JSON.stringify(this.localQuickProjects));
            localStorage.setItem("workroom-quick-items", JSON.stringify(this.localQuickItems));
        } catch (e) {
            return;
        }
    }

    private async syncLocalQuickDataToServer() {
        if (!this.localQuickItems.length) return;
        const migratedIds: string[] = [];

        for (const localItem of this.localQuickItems) {
            const normalized = this.normalizeItem(localItem);
            const existing = this.findTaskForLocalItem(normalized);
            const payload = this.taskPayloadFromItem(normalized);
            try {
                const response = existing
                    ? await wiz.call("update_task", { id: existing.id, data: JSON.stringify(payload) })
                    : await wiz.call("create_task", { data: JSON.stringify(payload) });
                if (response.code === 200 && response.data?.task) {
                    this.replaceTaskRow(response.data.task);
                    migratedIds.push(localItem.id);
                }
            } catch (e) {
                continue;
            }
        }

        if (migratedIds.length) {
            this.localQuickItems = this.localQuickItems.filter((item) => !migratedIds.includes(item.id));
            this.saveLegacyQuickData();
        }
    }

    private findTaskForLocalItem(item: any): any {
        if (item.sourceTaskId) {
            const bySource = this.taskRows.find((task) => `${task.id}` === `${item.sourceTaskId}`);
            if (bySource) return bySource;
        }
        return this.taskRows.find((task) => this.normalizeTitle(task.title || task.result_title || "") === this.normalizeTitle(item.title || "") && this.normalizeKind(task.kind) === this.normalizeKind(item.kind));
    }

    private isLocalItemBackedByTask(item: any): boolean {
        return !!this.findTaskForLocalItem(item);
    }

    private replaceTaskRow(task: any) {
        if (!task?.id) return;
        const index = this.taskRows.findIndex((row) => `${row.id}` === `${task.id}`);
        if (index >= 0) {
            this.taskRows = this.taskRows.map((row, rowIndex) => rowIndex === index ? task : row);
        } else {
            this.taskRows = [task, ...this.taskRows];
        }
    }

    private mergeTaskProjects() {
        const next = [...this.projects];
        const upsert = (project: any) => {
            if (!project?.id || !project?.title) return;
            if (next.some((row) => row.id === project.id)) return;
            next.unshift(project);
        };

        this.localQuickProjects.forEach((project) => upsert(project));
        this.taskRows.forEach((task) => {
            const type = task.type || task.itemType || task.item_type || "";
            const taskProjectId = task.projectId || task.project_id || (type === "project" ? `task-${task.id}` : "");
            const taskProjectTitle = this.normalizeProjectTitle(task.projectName || task.project_title || task.audience || (type === "project" ? task.title : ""));
            upsert({
                id: taskProjectId,
                title: taskProjectTitle,
                status: task.status || "진행 중",
                owner: task.owner || "김지원",
                summary: task.summary || task.purpose || "",
            });
        });

        this.projects = next;
        this.refreshProjectFilters();
    }

    private refreshProjectFilters() {
        this.projectFilters = [{ id: "all", title: "전체 프로젝트" }, ...this.projects];
        if (this.exportProjectId !== "all" && !this.projects.some((project) => project.id === this.exportProjectId)) {
            this.exportProjectId = "all";
        }
    }

    private refreshDateFilters() {
        const months: any = {};
        this.allItems.forEach((item) => {
            [item.due, item.date, item.updated, item.created].forEach((value) => {
                const month = this.monthFromText(value);
                if (month) months[`month-${month}`] = `${month}월`;
            });
        });

        this.dateFilters = [
            { key: "all", label: "전체 날짜" },
            { key: "today", label: "오늘" },
            { key: "this-week", label: "이번 주" },
            { key: "this-month", label: "이번 달" },
            ...Object.keys(months)
                .sort((a, b) => Number(a.replace("month-", "")) - Number(b.replace("month-", "")))
                .map((key) => ({ key, label: months[key] })),
            { key: "done-archive", label: "완료/보관" },
            { key: "unscheduled", label: "날짜 미정" },
        ];
    }

    private sortItems(items: any[]): any[] {
        const sorted = [...items];
        sorted.sort((a, b) => {
            let result = 0;
            if (this.activeSort === "title-asc") {
                result = this.compareText(a.title, b.title);
            } else if (this.activeSort === "project-asc") {
                result = this.compareText(a.projectName, b.projectName) || this.compareText(a.title, b.title);
            } else if (this.activeSort === "created-desc") {
                result = this.dateScore(b.created || b.createdText || b.updated) - this.dateScore(a.created || a.createdText || a.updated);
            } else if (this.activeSort === "completion-desc") {
                result = this.completionRank(a) - this.completionRank(b) || this.dateScore(b.updated || b.date) - this.dateScore(a.updated || a.date);
            } else {
                result = this.dateScore(b.updated || b.date) - this.dateScore(a.updated || a.date) || this.compareText(a.title, b.title);
            }
            return result;
        });
        return sorted;
    }

    private compareText(a: string, b: string): number {
        return (a || "").localeCompare(b || "", "ko");
    }

    private statusRank(status: string): number {
        const order = ["초안", "진행 중", "검토 필요", "완료", "보관"];
        const index = order.indexOf(this.normalizeStatus(status || ""));
        return index >= 0 ? index : order.length;
    }

    private completionRank(item: any): number {
        const status = this.normalizeStatus(item.status || "");
        if (status === "완료") return 0;
        if (status === "보관") return 1;
        if ((item.progress || 0) >= 100) return 2;
        return 3 + this.statusRank(status);
    }

    private dateScore(value: any): number {
        const text = `${value || ""}`.trim();
        if (!text) return -8640000000000000;

        const now = new Date();
        const day = 24 * 60 * 60 * 1000;
        if (text.indexOf("방금") >= 0) return now.getTime() + 1000;
        if (text.indexOf("오늘") >= 0) return now.getTime();
        if (text.indexOf("어제") >= 0) return now.getTime() - day;
        if (text.indexOf("이번 주") >= 0) return now.getTime() - (day * 3);

        const iso = text.match(/(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?/);
        if (iso) {
            const parsed = new Date(Number(iso[1]), Number(iso[2]) - 1, Number(iso[3]), Number(iso[4] || 0), Number(iso[5] || 0));
            return parsed.getTime();
        }

        const matched = text.match(/(\d{1,2})월\s*(\d{1,2})일/);
        if (matched) {
            const parsed = new Date(now.getFullYear(), Number(matched[1]) - 1, Number(matched[2]));
            return parsed.getTime();
        }

        if (text.indexOf("완료") >= 0) return 1;
        if (text.indexOf("보관") >= 0) return 0;
        return -8640000000000000;
    }

    private matchesDateFilter(item: any, filter: string): boolean {
        const values = [
            item.due,
            item.date,
            item.updated,
            item.created,
            item.createdText,
            item.updatedText,
        ].filter((value) => !!value).map((value) => `${value}`);
        const text = values.join(" ");
        const status = this.normalizeStatus(item.status || "");

        if (filter === "today") return text.indexOf("오늘") >= 0 || text.indexOf("방금") >= 0;
        if (filter === "this-week") return text.indexOf("오늘") >= 0 || text.indexOf("어제") >= 0 || text.indexOf("이번 주") >= 0 || this.isWithinCurrentDays(values, 7);
        if (filter === "this-month") return text.indexOf("오늘") >= 0 || text.indexOf("어제") >= 0 || text.indexOf("이번 주") >= 0 || this.isCurrentMonth(values);
        if (filter.indexOf("month-") === 0) return values.some((value) => this.monthFromText(value) === Number(filter.replace("month-", "")));
        if (filter === "done-archive") return status === "완료" || status === "보관" || text.indexOf("완료") >= 0 || text.indexOf("보관") >= 0;
        if (filter === "unscheduled") return !values.length || text.indexOf("날짜 미정") >= 0;
        return true;
    }

    private monthFromText(value: any): number {
        const text = `${value || ""}`;
        const iso = text.match(/\d{4}-(\d{2})-\d{2}/);
        if (iso) return Number(iso[1]);
        const matched = text.match(/(\d{1,2})월/);
        if (matched) return Number(matched[1]);
        return 0;
    }

    private isWithinCurrentDays(values: string[], days: number): boolean {
        const now = new Date();
        const start = new Date(now.getFullYear(), now.getMonth(), now.getDate() - days + 1).getTime();
        const end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1).getTime();
        return values.some((value) => {
            const score = this.dateScore(value);
            return score >= start && score < end;
        });
    }

    private isCurrentMonth(values: string[]): boolean {
        const now = new Date();
        return values.some((value) => {
            const score = this.dateScore(value);
            if (score <= 0) return false;
            const date = new Date(score);
            return date.getFullYear() === now.getFullYear() && date.getMonth() === now.getMonth();
        });
    }

    private itemSearchText(item: any): string {
        const project = this.itemProject(item);
        const tags = item.tags || [];
        const links = [...(item.links || []), ...(item.attachments || [])];
        return [
            item.title,
            item.summary,
            item.description,
            item.memo,
            item.note,
            item.projectId,
            item.projectName,
            project?.title,
            project?.summary,
            project?.status,
            item.type,
            item.typeLabel,
            this.typeLabel(item.type),
            item.kind,
            item.kindLabel,
            this.kindLabel(item.kind),
            item.status,
            item.date,
            item.due,
            item.updated,
            item.created,
            ...tags,
            ...links.map((link: any) => `${link.label || ""} ${link.url || ""}`),
            ...(item.checklist || []).map((entry: any) => `${entry.label || ""}`),
        ].filter((value) => !!value).join(" ").toLowerCase();
    }

    private async loadWorkTasks() {
        this.taskLoading = true;
        this.taskLoadFailed = false;
        this.taskLoadMessage = "";

        try {
            const { code, data } = await wiz.call("tasks");
            if (code === 200) {
                this.taskRows = data.tasks || [];
                this.mergeTaskProjects();
            } else {
                this.taskLoadFailed = true;
                this.taskLoadMessage = data?.message || "작업 목록을 불러오지 못했습니다.";
            }
        } catch (error) {
            this.taskLoadFailed = true;
            this.taskLoadMessage = "작업 목록을 불러오지 못했습니다.";
        }

        this.taskLoading = false;
    }

    private taskToItem(task: any): any {
        const kind = this.normalizeKind(task.kind || "etc");
        const status = this.normalizeStatus(task.status || "초안");
        const type = task.type || task.itemType || task.item_type || (task.result_title || task.result_summary || task.result_url ? "output" : "work");
        const taskItemId = `task-${task.id}`;
        const projectId = task.projectId || task.project_id || (type === "project" ? taskItemId : this.defaultProjectId());
        const project = this.projectById(projectId);
        const projectName = this.normalizeProjectTitle(task.projectName || task.project_title || task.audience || project.title);
        const summary = task.summary || task.result_summary || task.purpose || "목적을 보완해 주세요.";
        const description = task.description || summary;
        const url = task.url || task.result_url || "";
        const links = Array.isArray(task.links) && task.links.length ? task.links : (url ? [{ label: task.result_title || "바로 보기", url }] : []);
        const attachments = Array.isArray(task.attachments) && task.attachments.length ? task.attachments : links;
        const tags = Array.isArray(task.tags) && task.tags.length ? task.tags : [this.kindLabel(kind), "요청"].filter((tag) => !!tag);
        return {
            id: taskItemId,
            sourceTaskId: task.id,
            type,
            kind,
            title: task.title || task.result_title,
            projectId,
            projectName,
            status,
            progress: typeof task.progress === "number" ? task.progress : this.statusProgress(status),
            date: task.date || task.date_label || task.due || task.updatedText || task.createdText || "날짜 미정",
            due: task.due || "날짜 미정",
            updated: task.updatedText || task.createdText || "최근",
            created: task.createdText || task.updatedText || "",
            owner: task.owner || "김지원",
            tags: this.normalizeTags(tags, type, kind),
            description,
            summary,
            thumbnail: task.thumbnail || task.cover || "",
            cover: task.cover || task.thumbnail || "",
            url,
            relatedIds: task.relatedIds || task.related_ids || [],
            connectedIds: task.connectedIds || task.connected_ids || [],
            referenceIds: task.referenceIds || task.reference_ids || [],
            attachments,
            links,
            memo: task.memo || task.reference || "",
            checklist: task.checklist || [],
            kindLabel: this.kindLabel(kind),
            typeLabel: this.typeLabel(type),
        };
    }

    private normalizeStatus(status: string): string {
        status = `${status || ""}`.trim();
        if (status === "초안" || status === "아이디어" || status === "요청됨") return "초안";
        if (["완료", "완성본"].includes(status)) return "완료";
        if (status === "공유 대기") return "검토 필요";
        if (["작성 중", "진행 중"].includes(status)) return "진행 중";
        if (status.indexOf("검토") >= 0) return "검토 필요";
        if (status === "보관" || status === "보관본" || status === "아카이브") return "보관";
        return "초안";
    }

    private statusProgress(status: string): number {
        if (status === "완료") return 100;
        if (status === "검토 필요") return 75;
        if (status === "진행 중") return 48;
        if (status === "보관") return 100;
        return 10;
    }

    private createQuickForm(type: string): any {
        const defaults = this.quickDefaults(type);
        const activeKind = this.activeKind !== "all" && type !== "project" ? this.activeKind : defaults.kind;
        return {
            title: "",
            type,
            kind: activeKind,
            projectId: this.defaultProjectId(),
            status: defaults.status,
            due: "",
            tags: "",
            summary: "",
            reference: "",
            checklist: "",
            linkLabel: defaults.linkLabel,
            linkUrl: "",
        };
    }

    private quickDefaults(type: string): any {
        if (type === "project") return { kind: "document", status: "진행 중", linkLabel: "프로젝트" };
        if (type === "reference") return { kind: "link", status: "보관", linkLabel: "참고자료" };
        if (type === "output") return { kind: "presentation", status: "완료", linkLabel: "결과물" };
        return { kind: "proposal", status: "초안", linkLabel: "작업물" };
    }

    private defaultProjectId(): string {
        if (this.selectedItem?.projectId) return this.selectedItem.projectId;
        return this.projects[0]?.id || "unassigned";
    }

    private shouldPreflightResource(url: string): boolean {
        if (!url) return false;
        return url.indexOf("/assets/") === 0 || url.indexOf(location.origin + "/assets/") === 0;
    }

    private makeLocalId(prefix: string, title: string): string {
        const slug = (title || "item")
            .toLowerCase()
            .replace(/[^a-z0-9가-힣]+/g, "-")
            .replace(/^-+|-+$/g, "")
            .slice(0, 24) || "item";
        return `${prefix}-${slug}-${this.service.random(6)}`;
    }

    private compactText(value: any): string {
        return `${value || ""}`.trim();
    }

    private taskPayloadFromItem(item: any): any {
        const project = this.projectById(item.projectId);
        const links = item.links && item.links.length ? item.links : (item.attachments || []);
        const attachments = item.attachments && item.attachments.length ? item.attachments : links;
        const summary = item.summary || item.description || "";
        return {
            type: item.type || "work",
            kind: item.kind || "etc",
            title: item.title || "",
            status: item.status || "초안",
            purpose: summary,
            audience: item.projectName || project.title,
            due: item.due || item.date || "",
            reference: item.reference || item.memo || "",
            result_title: item.type === "output" ? item.title || "" : item.result_title || "",
            result_url: item.type === "output" ? item.url || "" : item.result_url || "",
            result_summary: item.type === "output" ? summary : item.result_summary || "",
            project_id: item.projectId || project.id,
            project_title: item.projectName || project.title,
            owner: item.owner || "김지원",
            tags: item.tags || [],
            description: item.description || summary,
            summary,
            cover: item.cover || "",
            thumbnail: item.thumbnail || item.cover || "",
            url: item.url || "",
            links,
            attachments,
            memo: item.memo || "",
            checklist: item.checklist || [],
            related_ids: item.relatedIds || [],
            connected_ids: item.connectedIds || [],
            reference_ids: item.referenceIds || [],
            progress: typeof item.progress === "number" ? item.progress : this.statusProgress(item.status || "초안"),
            date: item.date || item.due || "",
        };
    }

    private createExportSnapshot(scopeType: string, projectId: string = "all"): any {
        const allItems = this.allItems.map((item) => this.normalizeItem(item));
        const items = scopeType === "project"
            ? allItems.filter((item) => item.projectId === projectId)
            : allItems;
        const itemRows = items.map((item) => this.exportItem(item));
        const projectIds = scopeType === "project"
            ? [projectId]
            : this.projects.map((project) => project.id);
        const projectRows = this.projects
            .filter((project) => projectIds.includes(project.id))
            .map((project) => this.exportProject(project, itemRows));
        const tags = this.uniqueValues(itemRows.reduce((values: any[], item: any) => [...values, ...(item.tags || [])], []));
        const statuses = this.uniqueValues(itemRows.map((item) => item.status));
        const checklistCount = itemRows.reduce((sum, item) => sum + (item.checklist || []).length, 0);
        const linkCount = itemRows.reduce((sum, item) => sum + (item.links || []).length + (item.attachments || []).length, 0);
        const targetProject = scopeType === "project" ? this.projectById(projectId) : null;

        return {
            schema: "sirius.workroom.export",
            schemaVersion: 1,
            exportedAt: new Date().toISOString(),
            source: {
                app: "sirius",
                page: "dashboard",
                url: location.pathname,
            },
            scope: {
                type: scopeType,
                projectId: targetProject?.id || "all",
                projectTitle: targetProject?.title || "전체 작업물",
            },
            counts: {
                projects: projectRows.length,
                items: itemRows.length,
                tags: tags.length,
                links: linkCount,
                checklistItems: checklistCount,
            },
            projects: projectRows,
            items: itemRows,
            indexes: {
                tags,
                statuses,
                projectItems: projectRows.reduce((index: any, project: any) => {
                    index[project.id] = project.itemIds;
                    return index;
                }, {}),
            },
            importPlan: {
                targetApi: "page.dashboard.create_task/update_task",
                primaryKey: "id",
                projectKey: "projectId",
                payloadField: "taskPayload",
                relationshipFields: ["relatedIds", "connectedIds", "referenceIds"],
            },
        };
    }

    private exportProject(project: any, items: any[]): any {
        const projectItems = items.filter((item) => item.projectId === project.id);
        return {
            id: project.id,
            title: project.title,
            status: this.normalizeStatus(project.status || "초안"),
            owner: project.owner || "김지원",
            summary: project.summary || "",
            itemIds: projectItems.map((item) => item.id),
            counts: {
                items: projectItems.length,
                active: projectItems.filter((item) => ["초안", "진행 중", "검토 필요"].includes(item.status)).length,
                done: projectItems.filter((item) => item.status === "완료" || item.status === "보관").length,
                outputs: projectItems.filter((item) => item.type === "output").length,
            },
        };
    }

    private exportItem(item: any): any {
        const normalized = this.normalizeItem(item);
        return {
            id: normalized.id,
            sourceTaskId: normalized.sourceTaskId || "",
            source: normalized.sourceTaskId ? "work_task" : (String(normalized.id || "").indexOf("local-") === 0 ? "local" : "catalog"),
            type: normalized.type,
            kind: normalized.kind,
            title: normalized.title || "",
            status: normalized.status,
            progress: normalized.progress || 0,
            projectId: normalized.projectId || "",
            projectName: normalized.projectName || "",
            owner: normalized.owner || "",
            due: normalized.due || "",
            date: normalized.date || "",
            created: normalized.created || "",
            updated: normalized.updated || "",
            summary: normalized.summary || "",
            description: normalized.description || "",
            memo: normalized.memo || "",
            tags: this.cloneJson(normalized.tags || []),
            links: this.cloneJson(normalized.links || []),
            attachments: this.cloneJson(normalized.attachments || []),
            checklist: this.cloneJson(normalized.checklist || []),
            relatedIds: this.cloneJson(normalized.relatedIds || []),
            connectedIds: this.cloneJson(normalized.connectedIds || []),
            referenceIds: this.cloneJson(normalized.referenceIds || []),
            cover: normalized.cover || "",
            thumbnail: normalized.thumbnail || "",
            url: normalized.url || "",
            result: {
                title: normalized.result_title || (normalized.type === "output" ? normalized.title || "" : ""),
                url: normalized.result_url || (normalized.type === "output" ? normalized.url || "" : ""),
                summary: normalized.result_summary || (normalized.type === "output" ? normalized.summary || "" : ""),
            },
            taskPayload: this.taskPayloadFromItem(normalized),
        };
    }

    private uniqueValues(values: any[]): string[] {
        return values
            .filter((value) => value !== undefined && value !== null && `${value}`.trim() !== "")
            .map((value) => `${value}`.trim())
            .filter((value, index, rows) => rows.indexOf(value) === index)
            .sort((a, b) => a.localeCompare(b, "ko"));
    }

    private cloneJson(value: any): any {
        try {
            return JSON.parse(JSON.stringify(value || []));
        } catch (e) {
            return Array.isArray(value) ? [...value] : value;
        }
    }

    private exportFilename(scopeType: string, projectId: string = "all"): string {
        const date = new Date().toISOString().slice(0, 10);
        const suffix = scopeType === "project" ? this.filenameSafe(projectId) : "all";
        return `sirius-workroom-${suffix}-${date}.json`;
    }

    private filenameSafe(value: string): string {
        return `${value || "export"}`
            .toLowerCase()
            .replace(/[^a-z0-9가-힣_-]+/g, "-")
            .replace(/^-+|-+$/g, "")
            .slice(0, 60) || "export";
    }

    private downloadJson(data: any, filename: string) {
        const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json;charset=utf-8" });
        const url = URL.createObjectURL(blob);
        const anchor = document.createElement("a");
        anchor.href = url;
        anchor.download = filename;
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
        window.setTimeout(() => URL.revokeObjectURL(url), 1000);
    }

    private composeQuickReference(reference: string, tags: string[], linkUrl: string, checklist: any[]): string {
        return [
            reference,
            tags.length ? `태그: ${tags.join(", ")}` : "",
            linkUrl ? `링크: ${linkUrl}` : "",
            checklist.length ? `체크리스트: ${checklist.map((entry) => entry.label).join(" / ")}` : "",
        ].filter((line) => !!line).join("\n");
    }

    private parseTags(value: string): string[] {
        return this.normalizeTags((value || "")
            .split(",")
            .map((tag) => tag.trim())
            .filter((tag) => !!tag));
    }

    private parseChecklist(value: string): any[] {
        return (value || "")
            .split(/\n|,/)
            .map((label) => label.trim())
            .filter((label) => !!label)
            .map((label) => ({ label, done: false }));
    }

    private normalizeKind(kind: string): string {
        if (kind === "minutes") return "document";
        if (this.kindFilters.some((item) => item.key === kind)) return kind;
        return "etc";
    }

    private normalizeItem(item: any): any {
        const localStatus = item.sourceTaskId ? "" : this.statusOverrides[item.id];
        const type = item.type || "work";
        const kind = this.normalizeKind(item.kind || "etc");
        const project = this.projectById(item.projectId);
        let status = this.normalizeStatus(localStatus || item.status || "초안");
        if (type === "reference" && status === "완료") status = "보관";
        const links = item.links && item.links.length ? item.links : (item.attachments || []);
        const attachments = item.attachments && item.attachments.length ? item.attachments : links;
        const thumbnail = item.thumbnail || item.cover || "";
        const relatedIds = item.relatedIds || item.connectedIds || [];
        const summary = item.summary || item.description || this.defaultItemSummary(item, type, kind, project);
        const description = item.description || summary;
        const tags = this.normalizeTags(item.tags || [], type, kind);
        const date = this.normalizedDate(item, status);
        const checklist = item.checklist || this.defaultChecklist({ ...item, summary, description, tags }, status);

        return {
            ...item,
            title: this.normalizeTitle(item.title || ""),
            type,
            kind,
            status,
            progress: typeof item.progress === "number" ? item.progress : this.statusProgress(status),
            projectName: this.normalizeProjectTitle(item.projectName || project.title),
            description,
            summary,
            created: item.created || item.createdText || item.updated || item.date || item.due || "",
            date,
            due: item.due || item.date || date,
            tags,
            thumbnail,
            cover: thumbnail,
            attachments,
            links,
            relatedIds,
            connectedIds: relatedIds,
            referenceIds: item.referenceIds || [],
            memo: item.memo || item.note || "",
            checklist,
            kindLabel: this.kindLabel(kind),
            typeLabel: this.typeLabel(type),
        };
    }

    private normalizeProjectTitle(title: string): string {
        const aliases: any = {
            "개인 작업물 데이터베이스": "Sirius Workroom 개편",
            "고교학점제 운영 지원": "고교학점제 운영 지원 자료",
            "국가유산 제안서 패키지": "국가유산 분류 시각자료",
            "월간 세미나 발표": "월간 세미나 공유 자료",
        };
        const value = `${title || ""}`.trim();
        return aliases[value] || value;
    }

    private normalizeTitle(title: string): string {
        const aliases: any = {
            "개인 작업물 데이터베이스 개편": "Sirius Workroom 카탈로그 개편",
            "고교학점제 제안서": "고교학점제 운영 지원 제안서",
            "고교학점제 발표자료": "고교학점제 운영 지원 발표자료",
            "고교학점제 참고 메모": "고교학점제 정책·운영 참고 메모",
            "월간 세미나 발표자료": "Season Docs 월간 세미나 발표자료",
            "국가유산 유형분류 제안서형": "국가유산 유형분류 제안서 이미지",
            "국가유산 유형분류 기본안": "국가유산 유형분류 기본 이미지",
            "국가유산 제안서 페이지 샘플": "국가유산 제안서 렌더 샘플",
            "AI 업무 자동화 제안서": "AI 업무 자동화 제안서 초안",
            "운영 주간 회의록": "운영 주간 회의록 정리",
            "고교학점제 제안서 원본 PDF": "고교학점제 기존 제안서 PDF",
            "고교학점제 발표자료 원본 PDF": "고교학점제 기존 발표자료 PDF",
            "고교학점제 제안요청서": "고교학점제 제안요청서 원본",
            "고교학점제 요구사항": "고교학점제 요구사항 원본",
            "고교학점제 작성 요령": "고교학점제 작성 요령 원본",
        };
        const value = `${title || ""}`.trim();
        return aliases[value] || value;
    }

    private normalizeTags(tags: any[], type: string = "", kind: string = ""): string[] {
        const aliases: any = {
            "발표자료 작성": "발표자료",
            "제안서 작성": "제안서",
            "문서 작성": "문서",
            "이미지 작업": "이미지",
            "링크 정리": "링크",
            "메모 작성": "메모",
            "기타 작업": "기타",
            "기존자료": "기존 자료",
            "시각자료": "시각 자료",
            "작성요령": "작성 요령",
            "화면캡처": "화면 캡처",
            "액션아이템": "액션 아이템",
            "pdf": "PDF",
            "hwp": "HWP",
            "svg": "SVG",
            "ux": "UX",
        };
        return (tags || [])
            .map((tag) => `${tag || ""}`.trim())
            .filter((tag) => !!tag)
            .map((tag) => aliases[tag] || aliases[tag.toLowerCase()] || tag)
            .filter((tag, index, rows) => rows.indexOf(tag) === index)
            .filter((tag) => !(type === "reference" && tag === "참고자료"))
            .filter((tag) => !(kind && tag === `${this.kindLabel(kind)} 작성`));
    }

    private normalizedDate(item: any, status: string): string {
        const value = item.date || item.due || "";
        if (value && !["완료", "보관"].includes(value)) return value;
        return item.updated || item.created || item.createdText || item.updatedText || (status === "보관" ? "보관" : "날짜 미정");
    }

    private defaultItemSummary(item: any, type: string, kind: string, project: any): string {
        const projectTitle = this.normalizeProjectTitle(project?.title || item.projectName || "프로젝트");
        return `${projectTitle}에 연결된 ${this.kindLabel(kind)} ${this.typeLabel(type)}입니다.`;
    }

    private defaultChecklist(item: any, status: string): any[] {
        const hasAttachment = !!(item.url || (item.links && item.links.length) || (item.attachments && item.attachments.length));
        const hasRelation = !!((item.relatedIds && item.relatedIds.length) || (item.connectedIds && item.connectedIds.length) || (item.referenceIds && item.referenceIds.length));
        return [
            { label: "제목/설명", done: !!(item.title && (item.summary || item.description)) },
            { label: "프로젝트/태그", done: !!(item.projectId && item.tags && item.tags.length) },
            { label: "첨부/관계", done: hasAttachment || hasRelation || status === "완료" || status === "보관" },
        ];
    }

    private fallbackProject(): any {
        return {
            id: "unassigned",
            title: "분류되지 않은 프로젝트",
            status: "초안",
            owner: "김지원",
            summary: "프로젝트가 아직 연결되지 않은 항목입니다.",
        };
    }
}

export default PageDashboardComponent;